import { Button, CircularProgress, Input, Modal, Option, Select, selectClasses, styled, SvgIcon, Textarea } from "@mui/joy"
import { BASE_URL, BLACK, PRIMARY, WHITE } from "../../appConstants";
import React, { ChangeEvent, Dispatch, FormEvent, SetStateAction, useEffect, useMemo, useRef, useState } from "react";
import { DatePicker, DateValidationError, DesktopDatePicker, LocalizationProvider, PickerChangeHandlerContext } from "@mui/x-date-pickers";
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import axios from "axios";
import toast from "react-hot-toast";
import appError from "../../appError";
import { useSelector } from "react-redux";
import { formatDateTime, getNextMonthLastDate, getDateString, getFutureDate, getTimeString, getUTC } from "../../appFunctions";
import { UUID } from "crypto";
import TimeSlotInput from "../commonComponents/TimeSlotInput";
import dayjs, { Dayjs } from "dayjs";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Joi, { boolean } from "joi";
import { useNavigate } from "react-router-dom";
type AddKeywordTypeProps = {
    setOpenModal: Dispatch<SetStateAction<boolean>>,
    setRefresh: Dispatch<SetStateAction<boolean>>
}


interface AccountInfo {
    marketplaceStringId: string;
    id: string;
    type: string;
    name: string;
    validPaymentMethod: boolean;
}

interface ProfileObject {
    profileId: number;
    countryCode: string;
    currencyCode: string;
    dailyBudget: number;
    timezone: string;
    accountInfo: AccountInfo;
}

type FileDetailObj = {
    file_id: string,
    file_name: string,
    created_time_stamp: string,
    schedule_name: string,
    schedule_type: string,
    profile_obj: ProfileObject
}

type UploadStateObject = {
    file_id: string,
    file_name: string,
    created_time_stamp: string,
    schedule_name: string,
    schedule_type: string,
    profile_obj: ProfileObject

}


type TimeSlotObject = {
    type: string,
    week_days: (number | undefined)[],
    time_slots: string[]
}

type StateObject = {
    start_time_stamp: Date | null,
    end_time_stamp: Date | null,
    time_slots: TimeSlotObject,
    emails: []
}
type HourAndMin = {
    hour: string;
    min: string;
}



const AddBulkScheduleModal: React.FC<AddKeywordTypeProps> = ({ setOpenModal, setRefresh }) => {
    const brandId = useSelector((state: any) => state.appData.brand_id);
    const {
        stage,
        brand_id,
        platform_id,
        onboarding_type,
        brand_power_bi_dashboard_id,
        brand_power_bi_dashboard_type_id,
    } = useSelector((state: any) => state.appData);
    const [view, setView] = useState<string>("upload_file");


    const [fileDetail, setFileDetail] = useState<FileDetailObj>({} as FileDetailObj);



    type UploadFileComponentProps = {
        fileDetail: FileDetailObj,
        setFileDetail: Dispatch<SetStateAction<FileDetailObj>>
        onNextClickHandler: (state: UploadStateObject) => void
    }

    const UploadFileComponent: React.FC<UploadFileComponentProps> = ({ onNextClickHandler }) => {



        const [loadingUploadExcel, setLoadingUploadExcel] = useState<boolean>(false);
        const [profileObject, setProfileObject] = useState<ProfileObject[]>([] as ProfileObject[]);
        const [selectedProfileObject, setSelectedProfileObject] = useState<string>("");
        const [state, setState] = useState<UploadStateObject>({} as UploadStateObject);
        const [loading, setLoading] = useState<boolean>(false);

        useEffect(() => {
            fetchBulkFileDetail();
        }, [brandId]);

        const fetchBulkFileDetail = async () => {

            try {
                //setLoadingUnmappedData(true);
                const token = localStorage.getItem("token");
                if (!brandId) {
                    return;
                }
                const bulkFilesDetailRes = await axios.get(`${BASE_URL}brand/getProfileIdObject?brand_id=${brandId}`,
                    {
                        headers: {
                            "Authorization": `Bearer ${token}`
                        }
                    });

                const profile_detail_array = bulkFilesDetailRes?.data?.data?.profile_detail_array;
                let arr: ProfileObject[] = []
                for (let el of profile_detail_array) {
                    let profile_obj = JSON.parse(el?.profile_obj);
                    arr.push(profile_obj)
                }


                setProfileObject(arr);
                // setFileDetailArray(bulk_file_detail_array);

            } catch (error) {
                appError(error);
            } finally {
                // setLoadingUnmappedData(false);
            }

        }

        const onFileChange = async (event: ChangeEvent<HTMLInputElement>) => {

            if (!(event.target.files && event.target.files.length > 0)) {
                return appError("File not selected.");
            }

            try {
                setLoadingUploadExcel(true);
                let file = event.target.files[0];



                const token = localStorage.getItem("token");

                const resOne = await axios.post(`${BASE_URL}brand/bulk/fileDetail/validate?brand_id=${brandId}&platform_id=${platform_id}&dashboard_type_id=${brand_power_bi_dashboard_type_id}`,
                    { file_name: file?.name },
                    {
                        headers: {
                            "Authorization": `Bearer ${token}`
                        }
                    }
                );


                const formData = new FormData();
                formData.append('myFile', file);


                const res = await axios.post(`${BASE_URL}brand/bulk/fileUpload?brand_id=${brandId}&platform_id=${platform_id}&dashboard_type_id=${brand_power_bi_dashboard_type_id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        "Authorization": `Bearer ${token}`
                    }
                });
                const { message, data: { filename, originalname, created_time_stamp } } = res?.data;
                setState(prevState => ({
                    ...prevState,
                    file_id: filename,
                    file_name: originalname,
                    created_time_stamp
                }));
                toast.success(message);
            } catch (err: any) {
                console.log(err);
                setState(prevState => ({
                    ...prevState,
                    file_id: "",
                    file_name: "",
                    created_time_stamp: ""
                }));
                appError(err?.response?.data?.data?.message);
            } finally {
                setLoadingUploadExcel(false);
            }

        };



        const VisuallyHiddenInput = styled('input')`
                    clip: rect(0 0 0 0);
                    clip-path: inset(50%);
                    height: 1px;
                    overflow: hidden;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    white-space: nowrap;
                    width: 1px;
                    `;

        const onScheduleTypeHandler = (event: any, value: any) => {
            setState(prevState => ({ ...prevState, schedule_type: value }))
        }

        const onProfileChangeHandler = (event: any, value: any) => {

            const find: ProfileObject | undefined = profileObject?.find(el => el.profileId === value);
            if (find) {
                setState(prevState => ({ ...prevState, profile_obj: find }));

            }

        }


        const onInputChangeHandler = ({ target: { value, name } }: React.ChangeEvent<HTMLInputElement>): void => {
            setState(prevState => ({ ...prevState, schedule_name: value }));
        }

        const onNextClick = async () => {

            const schema = Joi.object({
                file_name: Joi.string(),
                created_time_stamp: Joi.string(),
                schedule_name: Joi.any().required().messages({
                    "any.required": "Please enter schedule name."
                }),
                schedule_type: Joi.string().required().messages({
                    "any.required": "Please select schedule type."
                }),
                file_id: Joi.string().required().messages({
                    "string.base": "Please upload file.",
                    "any.required": "Please upload file."
                }),
                profile_id: Joi.number().required().messages({
                    "string.base": "Please select profile id.",
                    "any.required": "Please select profile id."
                })
            });





            const { file_name, created_time_stamp, schedule_name, schedule_type, file_id, profile_obj: { profileId: profile_id } } = state;

            const validate = schema.validate({ file_name, created_time_stamp, schedule_name, schedule_type, file_id, profile_id });
            if (validate.error) {
                appError(validate?.error?.toString());
                return;
            }

            try {
                setLoading(true);
                const token = localStorage.getItem("token");

                const res = await axios.post(`${BASE_URL}brand/bulk/fileDetail/validate?brand_id=${brandId}&platform_id=${platform_id}&dashboard_type_id=${brand_power_bi_dashboard_type_id}`,
                    { schedule_name },
                    {
                        headers: {
                            "Authorization": `Bearer ${token}`
                        }
                    }
                );
            } catch (error) {
                appError(error);
                return;
            } finally {
                setLoading(false);
            }

            onNextClickHandler(state);

        }

        return (
            <>
                <div style={{ height: 46 }} className="flex flex-col justify-between" >
                    <div style={{ fontSize: 16, fontWeight: 600, color: BLACK.B_100 }}>Create New Bulk Scheduling</div>
                    <p style={{ fontSize: 12, fontWeight: 400, color: BLACK.B_40 }} >Add Bulk File here</p>
                </div>
                <div className="flex justify-between mt-6">
                    <div>
                        <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_80 }}>Schedule Name</div>
                        <Input
                            autoComplete="off"
                            placeholder="Add Scheduling Name"
                            sx={{
                                "--Input-focusedThickness": "0px",
                                width: "340px",
                                height: "52px",
                                backgroundColor: WHITE.W_100,
                                fontSize: 14,
                                fontWeight: 400,
                                lineHeight: "20px"
                            }}
                            name="schedule_name"
                            value={state?.schedule_name}
                            onChange={onInputChangeHandler}
                        />
                    </div>
                    <div >
                        <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_80 }}>Schedule Type</div>
                        <Select
                            onChange={onScheduleTypeHandler}
                            placeholder="Select Type"
                            name="schedule_type"
                            value={state?.schedule_type}
                            indicator={
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 12.4791C9.88891 12.4791 9.78474 12.4617 9.68752 12.427C9.5903 12.3923 9.50002 12.3333 9.41669 12.2499L5.58335 8.41659C5.43058 8.26381 5.35419 8.06936 5.35419 7.83325C5.35419 7.59714 5.43058 7.4027 5.58335 7.24992C5.73613 7.09714 5.93058 7.02075 6.16669 7.02075C6.4028 7.02075 6.59724 7.09714 6.75002 7.24992L10 10.4999L13.25 7.24992C13.4028 7.09714 13.5972 7.02075 13.8334 7.02075C14.0695 7.02075 14.2639 7.09714 14.4167 7.24992C14.5695 7.4027 14.6459 7.59714 14.6459 7.83325C14.6459 8.06936 14.5695 8.26381 14.4167 8.41659L10.5834 12.2499C10.5 12.3333 10.4097 12.3923 10.3125 12.427C10.2153 12.4617 10.1111 12.4791 10 12.4791Z" fill="#1C1C1C" fill-opacity="0.4" />
                                </svg>

                            }
                            sx={{
                                "--Input-focusedThickness": "0px",
                                width: "340px",
                                height: "52px",
                                backgroundColor: WHITE.W_100,
                                fontSize: 14,
                                fontWeight: 400,
                                lineHeight: "20px",
                                [`& .${selectClasses.indicator}`]: {
                                    transition: '0.2s',
                                    [`&.${selectClasses.expanded}`]: {
                                        transform: 'rotate(-180deg)',
                                    },
                                },
                            }}>
                            <Option value={"one_time"} >One Time</Option>
                            <Option value={"recurring"} >Recurring</Option>
                            {/* <Option value={"CLIENT"}>CLIENT</Option> */}
                        </Select>
                    </div>
                </div>
                <div className="flex flex-col justify-between mt-6">
                    <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_80 }}>Select Profile</div>
                    <Select

                        onChange={onProfileChangeHandler}
                        placeholder="Select Profile"
                        name="profile_id"
                        value={state?.profile_obj?.profileId}
                        indicator={
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M10 12.4791C9.88891 12.4791 9.78474 12.4617 9.68752 12.427C9.5903 12.3923 9.50002 12.3333 9.41669 12.2499L5.58335 8.41659C5.43058 8.26381 5.35419 8.06936 5.35419 7.83325C5.35419 7.59714 5.43058 7.4027 5.58335 7.24992C5.73613 7.09714 5.93058 7.02075 6.16669 7.02075C6.4028 7.02075 6.59724 7.09714 6.75002 7.24992L10 10.4999L13.25 7.24992C13.4028 7.09714 13.5972 7.02075 13.8334 7.02075C14.0695 7.02075 14.2639 7.09714 14.4167 7.24992C14.5695 7.4027 14.6459 7.59714 14.6459 7.83325C14.6459 8.06936 14.5695 8.26381 14.4167 8.41659L10.5834 12.2499C10.5 12.3333 10.4097 12.3923 10.3125 12.427C10.2153 12.4617 10.1111 12.4791 10 12.4791Z" fill="#1C1C1C" fill-opacity="0.4" />
                            </svg>

                        }
                        sx={{
                            "--Input-focusedThickness": "0px",
                            width: "340px",
                            height: "52px",
                            backgroundColor: WHITE.W_100,
                            fontSize: 14,
                            fontWeight: 400,
                            lineHeight: "20px",
                            [`& .${selectClasses.indicator}`]: {
                                transition: '0.2s',
                                [`&.${selectClasses.expanded}`]: {
                                    transform: 'rotate(-180deg)',
                                },
                            },
                        }}>
                        {
                            profileObject.map(el => {
                                return (
                                    <Option sx={{ height: 60 }} value={el?.profileId} >
                                        <div>
                                            <div className="flex" >
                                                <div  >
                                                    {el?.accountInfo?.name}
                                                </div>
                                                <div style={{ color: BLACK.B_80 }} className="ml-2" >({el?.accountInfo?.type})</div>
                                            </div>
                                            <div style={{ fontSize: 14, fontWeight: 500, lineHeight: "18px", color: BLACK.B_40 }} >{el?.accountInfo?.id}</div>
                                        </div>
                                    </Option>
                                )
                            })
                        }


                        {/* <Option value={"CLIENT"}>CLIENT</Option> */}
                    </Select>
                </div>

                <div className="mt-6" >
                    <Button
                        component="label"
                        role={undefined}
                        tabIndex={-1}
                        variant="outlined"
                        color="neutral"
                        style={{
                            height: 160,
                            width: 710,
                            border: `1px dashed ${BLACK.B_10}`
                        }}


                    >
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <svg className="mb-4" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                                <path d="M18.75 20.3587L16.5288 22.5546C16.3007 22.7851 16.0156 22.9004 15.6733 22.9004C15.3314 22.9004 15.0364 22.7765 14.7883 22.5288C14.5469 22.2979 14.4289 22.0053 14.4342 21.6508C14.4397 21.2961 14.5578 21.0033 14.7883 20.7725L18.9454 16.6154C19.2468 16.314 19.5983 16.1633 20 16.1633C20.4017 16.1633 20.7532 16.314 21.0546 16.6154L25.2117 20.7725C25.4422 21.0033 25.5644 21.2913 25.5783 21.6362C25.5922 21.9812 25.47 22.2792 25.2117 22.53C24.9808 22.76 24.6924 22.8765 24.3463 22.8796C24.0001 22.8829 23.7031 22.7692 23.455 22.5383L21.25 20.3587V29.4871C21.25 29.6154 21.3035 29.7329 21.4104 29.8396C21.5171 29.9465 21.6346 30 21.7629 30H30.8333C32 30 32.9861 29.5972 33.7917 28.7917C34.5972 27.9861 35 27 35 25.8333C35 24.6667 34.5972 23.6806 33.7917 22.875C32.9861 22.0694 32 21.6667 30.8333 21.6667H28.3333V18.3333C28.3333 16.0278 27.5208 14.0625 25.8958 12.4375C24.2708 10.8125 22.3056 10 20 10C17.6944 10 15.7292 10.8125 14.1042 12.4375C12.4792 14.0625 11.6667 16.0278 11.6667 18.3333H10.8013C9.22208 18.3333 7.86042 18.9028 6.71625 20.0417C5.57208 21.1806 5 22.5556 5 24.1667C5 25.7778 5.56944 27.1528 6.70833 28.2917C7.84722 29.4306 9.22222 30 10.8333 30H13.75C14.1042 30 14.4011 30.1199 14.6408 30.3596C14.8803 30.5993 15 30.8963 15 31.2504C15 31.6049 14.8803 31.9017 14.6408 32.1408C14.4011 32.3803 14.1042 32.5 13.75 32.5H10.8333C8.53 32.5 6.56528 31.701 4.93917 30.1029C3.31306 28.5049 2.5 26.5518 2.5 24.2438C2.5 22.1732 3.16611 20.3521 4.49833 18.7804C5.83056 17.2088 7.48278 16.2776 9.455 15.9871C9.98917 13.4957 11.2419 11.4583 13.2133 9.875C15.1844 8.29167 17.4467 7.5 20 7.5C23.0178 7.5 25.5778 8.55111 27.68 10.6533C29.7822 12.7556 30.8333 15.3156 30.8333 18.3333V19.1667H31.3463C33.1026 19.3033 34.5674 20.0096 35.7404 21.2854C36.9135 22.561 37.5 24.0769 37.5 25.8333C37.5 27.6922 36.859 29.2681 35.5771 30.5608C34.2949 31.8536 32.7243 32.5 30.8654 32.5H21.7629C20.921 32.5 20.2083 32.2083 19.625 31.625C19.0417 31.0417 18.75 30.329 18.75 29.4871V20.3587Z" fill="#1C1C1C" />
                            </svg>
                            <div style={{ display: "flex", alignItems: "center", fontSize: 14, fontWeight: 700, lineHeight: "20px", height: 40 }} >
                                Upload Your File <span className="ml-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: PRIMARY.P_BLue, borderBottom: `1px solid ${PRIMARY.P_BLue}` }} >Here</span>
                            </div>
                            <div style={{ fontSize: 10, fontWeight: 500, color: BLACK.B_20 }} >Please upload your data file here. Only .xlsx files are supported.</div>
                        </div>
                        <VisuallyHiddenInput
                            onChange={onFileChange}
                            type="file" />
                    </Button>
                </div>
                <div className="flex flex-row justify-between items-center mt-6" >
                    <div>
                        {
                            state?.file_id && (
                                <div className="flex items-center" >
                                    <div className="mr-2" >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                            <path d="M19.5001 26C19.5001 26.2652 19.3947 26.5196 19.2072 26.7071C19.0196 26.8946 18.7653 27 18.5001 27H15.0001C14.7348 27 14.4805 26.8946 14.293 26.7071C14.1054 26.5196 14.0001 26.2652 14.0001 26V19C14.0001 18.7348 14.1054 18.4804 14.293 18.2929C14.4805 18.1054 14.7348 18 15.0001 18C15.2653 18 15.5196 18.1054 15.7072 18.2929C15.8947 18.4804 16.0001 18.7348 16.0001 19V25H18.5001C18.7653 25 19.0196 25.1054 19.2072 25.2929C19.3947 25.4804 19.5001 25.7348 19.5001 26ZM11.5813 18.1863C11.4744 18.1099 11.3536 18.0554 11.2257 18.0258C11.0977 17.9961 10.9652 17.992 10.8357 18.0136C10.7061 18.0352 10.5821 18.0821 10.4707 18.1516C10.3593 18.2211 10.2626 18.3119 10.1863 18.4188L8.50006 20.78L6.81381 18.4188C6.7402 18.3055 6.6444 18.2083 6.53221 18.1331C6.42001 18.0579 6.29374 18.0062 6.161 17.9811C6.02827 17.956 5.89184 17.9581 5.75993 17.9872C5.62802 18.0163 5.50337 18.0718 5.39351 18.1504C5.28365 18.229 5.19085 18.329 5.12071 18.4445C5.05057 18.5599 5.00455 18.6884 4.98542 18.8221C4.96629 18.9558 4.97445 19.092 5.00941 19.2225C5.04436 19.353 5.10539 19.475 5.18881 19.5812L7.27131 22.5L5.18631 25.4188C5.04599 25.6346 4.99436 25.8963 5.04217 26.1494C5.08997 26.4024 5.23353 26.6272 5.44295 26.777C5.65237 26.9268 5.91151 26.9901 6.1664 26.9536C6.42129 26.9172 6.6523 26.7838 6.81131 26.5812L8.50006 24.22L10.1863 26.5812C10.3453 26.7838 10.5763 26.9172 10.8312 26.9536C11.0861 26.9901 11.3453 26.9268 11.5547 26.777C11.7641 26.6272 11.9076 26.4024 11.9555 26.1494C12.0033 25.8963 11.9516 25.6346 11.8113 25.4188L9.72881 22.5L11.8138 19.5812C11.8901 19.4744 11.9447 19.3535 11.9743 19.2256C12.0039 19.0977 12.0081 18.9651 11.9865 18.8356C11.9649 18.7061 11.918 18.582 11.8485 18.4706C11.779 18.3592 11.6882 18.2626 11.5813 18.1863ZM23.9488 21.4137C23.4488 21.2687 22.9313 21.12 22.6426 20.9338C22.4863 20.8312 22.4888 20.8088 22.5026 20.6963C22.5044 20.6054 22.5281 20.5162 22.5716 20.4364C22.6151 20.3566 22.6772 20.2883 22.7526 20.2375C23.3276 19.8475 24.6701 20.0225 25.2301 20.1675C25.4867 20.235 25.7595 20.1977 25.9887 20.064C26.2178 19.9303 26.3845 19.711 26.4519 19.4544C26.5194 19.1978 26.4822 18.9249 26.3484 18.6957C26.2147 18.4666 25.9954 18.3 25.7388 18.2325C25.4751 18.1637 23.1138 17.58 21.6351 18.5775C21.3232 18.7882 21.0615 19.0647 20.8682 19.3876C20.6749 19.7105 20.5547 20.0719 20.5163 20.4463C20.2663 22.4313 22.2226 22.9975 23.3913 23.335C24.8988 23.7712 25.0313 23.95 24.9888 24.2838C24.9501 24.585 24.8313 24.7 24.7201 24.775C24.1451 25.1575 22.8251 24.9688 22.2776 24.8188C22.0215 24.7476 21.7476 24.7812 21.5162 24.912C21.4017 24.9768 21.301 25.0635 21.2199 25.1671C21.1389 25.2708 21.079 25.3894 21.0438 25.5163C21.0086 25.6431 20.9987 25.7756 21.0147 25.9062C21.0307 26.0368 21.0723 26.163 21.137 26.2776C21.2678 26.509 21.4852 26.6789 21.7413 26.75C22.3611 26.9133 22.9991 26.9973 23.6401 27C24.3676 27 25.1776 26.875 25.8263 26.4425C26.1463 26.2297 26.4152 25.9485 26.6137 25.6194C26.8121 25.2902 26.9351 24.9211 26.9738 24.5387C27.2501 22.375 25.1851 21.7712 23.9488 21.4137ZM5.00006 14V5C5.00006 4.46957 5.21077 3.96086 5.58585 3.58579C5.96092 3.21071 6.46963 3 7.00006 3H19.0001C19.1314 2.9999 19.2615 3.02568 19.3829 3.07586C19.5043 3.12605 19.6146 3.19967 19.7076 3.2925L26.7076 10.2925C26.8004 10.3854 26.874 10.4958 26.9242 10.6172C26.9744 10.7385 27.0002 10.8686 27.0001 11V14C27.0001 14.2652 26.8947 14.5196 26.7072 14.7071C26.5196 14.8946 26.2653 15 26.0001 15C25.7348 15 25.4805 14.8946 25.293 14.7071C25.1054 14.5196 25.0001 14.2652 25.0001 14V12H19.0001C18.7348 12 18.4805 11.8946 18.293 11.7071C18.1054 11.5196 18.0001 11.2652 18.0001 11V5H7.00006V14C7.00006 14.2652 6.8947 14.5196 6.70717 14.7071C6.51963 14.8946 6.26528 15 6.00006 15C5.73484 15 5.48049 14.8946 5.29295 14.7071C5.10542 14.5196 5.00006 14.2652 5.00006 14ZM20.0001 10H23.5851L20.0001 6.41375V10Z" fill="#1C1C1C" fill-opacity="0.4" />
                                        </svg>
                                    </div>
                                    <div className="flex  flex-col" >
                                        <div className="mb-1" style={{ fontSize: 12, fontWeight: 500, color: BLACK.B_40 }} >{state?.file_name}</div>
                                        <div style={{ fontSize: 10, fontWeight: 500, color: BLACK.B_20 }} className="flex items-center" > {formatDateTime(state?.created_time_stamp)[0]} <svg className="mx-2" xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                                            <circle cx="2" cy="2" r="2" fill="#B8B8B8" />
                                        </svg>  {formatDateTime(state?.created_time_stamp)[1]}
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                    <div className="flex justify-center" >
                        {
                            loadingUploadExcel && <CircularProgress size="sm" />
                        }
                        {
                            state?.file_id && !loadingUploadExcel && (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M10.5808 14.1463L8.25775 11.823C8.11925 11.6847 7.94517 11.6138 7.7355 11.6105C7.526 11.6073 7.34875 11.6782 7.20375 11.823C7.05892 11.968 6.9865 12.1437 6.9865 12.35C6.9865 12.5563 7.05892 12.732 7.20375 12.877L9.948 15.6212C10.1288 15.8019 10.3398 15.8923 10.5808 15.8923C10.8218 15.8923 11.0327 15.8019 11.2135 15.6212L16.777 10.0578C16.9153 9.91925 16.9862 9.74517 16.9895 9.5355C16.9927 9.326 16.9218 9.14875 16.777 9.00375C16.632 8.85892 16.4563 8.7865 16.25 8.7865C16.0437 8.7865 15.868 8.85892 15.723 9.00375L10.5808 14.1463ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5Z" fill="#007F5F" />
                            </svg>
                            )
                        }
                    </div>
                </div>

                <div className="flex flex-row justify-between mt-10">
                    <Button color="neutral"
                        sx={{
                            height: "48px",
                            width: "340px",
                            backgroundColor: BLACK.B_5,
                            color: BLACK.B_100,
                            ":hover": {
                                backgroundColor: BLACK.B_20,
                            }
                        }}
                        onClick={() => setOpenModal(false)}
                    >Cancel</Button>
                    <Button
                        onClick={onNextClick}
                        // endDecorator={
                        //     <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                        //         <path d="M17.8172 10.4425L12.1922 16.0675C12.0749 16.1848 11.9159 16.2507 11.75 16.2507C11.5841 16.2507 11.4251 16.1848 11.3078 16.0675C11.1905 15.9503 11.1247 15.7912 11.1247 15.6253C11.1247 15.4595 11.1905 15.3004 11.3078 15.1832L15.8664 10.6253H3.625C3.45924 10.6253 3.30027 10.5595 3.18306 10.4423C3.06585 10.3251 3 10.1661 3 10.0003C3 9.83459 3.06585 9.67562 3.18306 9.55841C3.30027 9.4412 3.45924 9.37535 3.625 9.37535H15.8664L11.3078 4.81753C11.1905 4.70026 11.1247 4.5412 11.1247 4.37535C11.1247 4.2095 11.1905 4.05044 11.3078 3.93316C11.4251 3.81588 11.5841 3.75 11.75 3.75C11.9159 3.75 12.0749 3.81588 12.1922 3.93316L17.8172 9.55816C17.8753 9.61621 17.9214 9.68514 17.9529 9.76101C17.9843 9.83688 18.0005 9.91821 18.0005 10.0003C18.0005 10.0825 17.9843 10.1638 17.9529 10.2397C17.9214 10.3156 17.8753 10.3845 17.8172 10.4425Z" fill="white" />
                        //     </svg>
                        // }
                        sx={{
                            height: "48px",
                            width: "340px",
                            backgroundColor: PRIMARY.P_BLue,
                        }}
                        loading={loading}
                    >Next</Button>
                </div>

            </>
        )
    }

    const OneTimeSchedulingDetailComponent: React.FC<{ setRefresh: Dispatch<SetStateAction<boolean>> }> = ({ setRefresh }) => {
        const navigate = useNavigate();
        const [loading, setLoading] = useState<boolean>(false);
        const [oneTimeHourAndMin, setOneTimeHourAndMin] = useState<HourAndMin>({} as HourAndMin);
        const [emails, setEmails] = useState<string>("");
        const [state, setState] = useState<StateObject>({
            start_time_stamp: getUTC(new Date()),
            end_time_stamp: getUTC(new Date()),
            time_slots: {
                type: '',
                week_days: [
                    getUTC(new Date()).getDay()
                ],
                time_slots: []
            },
            emails: []
        });

        const setHourAndMinHandler = (unit: string, value: string) => {

            setOneTimeHourAndMin(prevState => ({
                ...prevState,
                [unit]: value
            }))
        }

        const onInputChangeHandler = ({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
            setEmails(value);
        }

        const onDateChangeHandler = (dateObje: Dayjs | null) => {
            const day = dateObje?.day();
            const date = dateObje?.date();
            const month = dateObje?.month();
            const year = dateObje?.year();

            const time_stamp = new Date(`${year}-${month as number + 1}-${date}`);

            const time_slots: TimeSlotObject = {} as TimeSlotObject;
            time_slots.week_days = [day];
            // time_slots.type = "one_time";
            setState(prevState => ({
                ...prevState,
                time_slots,
                start_time_stamp: time_stamp,
                end_time_stamp: time_stamp
            }));
        }

        const onSaveClickHandler = async () => {


            if (!(oneTimeHourAndMin.hour && oneTimeHourAndMin.min)) {
                appError("Please select time slot.");
                return;
            }


            if (!emails.length) {
                appError("Please provide email.");
                return
            }

            const { schedule_name, schedule_type, file_name, file_id, profile_obj } = fileDetail;
            const { start_time_stamp, end_time_stamp, time_slots: { week_days } } = state;

            const obj = {
                schedule_name,
                file_name,
                file_id,
                start_date: getDateString(start_time_stamp),
                end_date: getDateString(end_time_stamp),
                today_current_date: getDateString(new Date()),
                today_current_time: getTimeString(new Date()),
                emails: emails,
                time_slots: {
                    recurring_type: "one_time",
                    type: schedule_type,
                    time_slots: [`${oneTimeHourAndMin.hour}:${oneTimeHourAndMin.min}`],
                    week_days
                },
                profile_obj
            }
            let current_date_time_plus_one_hour = new Date(`${getDateString(new Date())}T${getTimeString(new Date())}`);
            current_date_time_plus_one_hour.setHours(current_date_time_plus_one_hour.getHours() + 1);
            let schedule_date_time = new Date(`${obj.start_date}T${obj.time_slots?.time_slots[0]}`);

            if (!(schedule_date_time > current_date_time_plus_one_hour)) {
                appError("Please choose a time at least 1 hour from the current time.");
                return;
            }

            try {
                setLoading(true);
                const token = localStorage.getItem("token");

                const res = await axios.post(`${BASE_URL}brand/bulk/fileDetail?brand_id=${brandId}&platform_id=${platform_id}&dashboard_type_id=${brand_power_bi_dashboard_type_id}`,
                    obj,
                    {
                        headers: {
                            "Authorization": `Bearer ${token}`
                        }
                    }
                );

                const { message, file_detail_id } = res?.data?.data;
                toast.success(message);
                setRefresh(prevState => !prevState);
                setOpenModal(false);
                navigate("/bulkUpload/allFiles");
            } catch (error) {
                appError(error);
            } finally {
                setLoading(false);
            }

        }

        return (
            <>
                <div style={{ height: 46 }} className="flex flex-col justify-between" >
                    <div style={{ fontSize: 16, fontWeight: 600, color: BLACK.B_100 }}>Create New Bulk Scheduling</div>
                    <p style={{ fontSize: 12, fontWeight: 400, color: BLACK.B_40 }} >Add Bulk File here</p>
                </div>
                <div className="flex justify-between mt-6">
                    <div>
                        <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_80 }}>Date</div>
                        <LocalizationProvider dateAdapter={AdapterDayjs} >
                            <DesktopDatePicker
                                minDate={dayjs(new Date())}
                                maxDate={dayjs(getNextMonthLastDate())}
                                defaultValue={dayjs(new Date())}
                                onChange={onDateChangeHandler}
                                slots={{
                                    openPickerIcon: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M6.6665 11.6186C6.46248 11.6186 6.28859 11.5467 6.14484 11.4031C6.00123 11.2594 5.92942 11.0855 5.92942 10.8815C5.92942 10.6774 6.00123 10.5036 6.14484 10.3598C6.28859 10.2161 6.46248 10.1442 6.6665 10.1442C6.87053 10.1442 7.04442 10.2161 7.18817 10.3598C7.33178 10.5036 7.40359 10.6774 7.40359 10.8815C7.40359 11.0855 7.33178 11.2594 7.18817 11.4031C7.04442 11.5467 6.87053 11.6186 6.6665 11.6186ZM9.99984 11.6186C9.79581 11.6186 9.62192 11.5467 9.47817 11.4031C9.33456 11.2594 9.26275 11.0855 9.26275 10.8815C9.26275 10.6774 9.33456 10.5036 9.47817 10.3598C9.62192 10.2161 9.79581 10.1442 9.99984 10.1442C10.2039 10.1442 10.3778 10.2161 10.5215 10.3598C10.6651 10.5036 10.7369 10.6774 10.7369 10.8815C10.7369 11.0855 10.6651 11.2594 10.5215 11.4031C10.3778 11.5467 10.2039 11.6186 9.99984 11.6186ZM13.3332 11.6186C13.1291 11.6186 12.9553 11.5467 12.8115 11.4031C12.6679 11.2594 12.5961 11.0855 12.5961 10.8815C12.5961 10.6774 12.6679 10.5036 12.8115 10.3598C12.9553 10.2161 13.1291 10.1442 13.3332 10.1442C13.5372 10.1442 13.7111 10.2161 13.8548 10.3598C13.9984 10.5036 14.0703 10.6774 14.0703 10.8815C14.0703 11.0855 13.9984 11.2594 13.8548 11.4031C13.7111 11.5467 13.5372 11.6186 13.3332 11.6186ZM4.42296 17.9167C4.00199 17.9167 3.64567 17.7708 3.354 17.4792C3.06234 17.1875 2.9165 16.8312 2.9165 16.4102V5.25647C2.9165 4.8355 3.06234 4.47918 3.354 4.18751C3.64567 3.89585 4.00199 3.75001 4.42296 3.75001H5.57671V2.62814C5.57671 2.4455 5.63789 2.293 5.76025 2.17064C5.88261 2.04842 6.03511 1.9873 6.21775 1.9873C6.40053 1.9873 6.55303 2.04842 6.67525 2.17064C6.79762 2.293 6.8588 2.4455 6.8588 2.62814V3.75001H13.173V2.6123C13.173 2.43494 13.2328 2.2864 13.3523 2.16668C13.4721 2.0471 13.6206 1.9873 13.798 1.9873C13.9753 1.9873 14.1238 2.0471 14.2434 2.16668C14.3631 2.2864 14.423 2.43494 14.423 2.6123V3.75001H15.5767C15.9977 3.75001 16.354 3.89585 16.6457 4.18751C16.9373 4.47918 17.0832 4.8355 17.0832 5.25647V16.4102C17.0832 16.8312 16.9373 17.1875 16.6457 17.4792C16.354 17.7708 15.9977 17.9167 15.5767 17.9167H4.42296ZM4.42296 16.6667H15.5767C15.6409 16.6667 15.6996 16.6399 15.753 16.5865C15.8064 16.5331 15.8332 16.4744 15.8332 16.4102V8.5898H4.1665V16.4102C4.1665 16.4744 4.19324 16.5331 4.24671 16.5865C4.30005 16.6399 4.3588 16.6667 4.42296 16.6667ZM4.1665 7.3398H15.8332V5.25647C15.8332 5.1923 15.8064 5.13355 15.753 5.08022C15.6996 5.02675 15.6409 5.00001 15.5767 5.00001H4.42296C4.3588 5.00001 4.30005 5.02675 4.24671 5.08022C4.19324 5.13355 4.1665 5.1923 4.1665 5.25647V7.3398Z" fill="#1C1C1C" fill-opacity="0.4" />
                                    </svg>
                                }}
                                format="DD-MMM-YY"
                                slotProps={{
                                    textField: {
                                        // placeholder: "Choose date",
                                        sx: {

                                            width: "340px",
                                            '& .MuiInputBase-root': {
                                                height: "52px"
                                            },
                                            '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${BLACK.B_10}`,
                                                borderRadius: '8px'
                                            },

                                            '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${BLACK.B_10}`
                                            },
                                            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${BLACK.B_10}`
                                            }
                                        }
                                    }
                                }}
                            />
                        </LocalizationProvider>
                    </div>
                    <div>
                        <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_80 }}>Time Slot</div>
                        <TimeSlotInput setHourAndMinHandler={setHourAndMinHandler} oneTimeHourAndMin={oneTimeHourAndMin} />

                    </div>

                </div>
                <div className="mt-6" >
                    <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_80 }}>Email ID</div>
                    <Input
                        autoComplete="off"
                        placeholder="Enter email IDs for notification, separated by ‘ , ‘"
                        sx={{
                            "--Input-focusedThickness": "0px",
                            width: "708px",
                            height: "52px",
                            backgroundColor: WHITE.W_100,
                            fontSize: 14,
                            fontWeight: 400,
                            lineHeight: "20px",
                            border: `1px solid ${BLACK.B_10}`
                        }}
                        name="company_name"
                        onChange={onInputChangeHandler}
                    />
                </div>


                <div className="flex flex-row justify-between mt-10">
                    <Button color="neutral"
                        sx={{
                            height: "48px",
                            width: "340px",
                            backgroundColor: BLACK.B_5,
                            color: BLACK.B_100,
                            ":hover": {
                                backgroundColor: BLACK.B_20,
                            }
                        }}
                        onClick={() => setOpenModal(false)}
                    >Cancel</Button>
                    <Button
                        onClick={onSaveClickHandler}
                        loading={loading}
                        // endDecorator={
                        //     <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                        //         <path d="M17.8172 10.4425L12.1922 16.0675C12.0749 16.1848 11.9159 16.2507 11.75 16.2507C11.5841 16.2507 11.4251 16.1848 11.3078 16.0675C11.1905 15.9503 11.1247 15.7912 11.1247 15.6253C11.1247 15.4595 11.1905 15.3004 11.3078 15.1832L15.8664 10.6253H3.625C3.45924 10.6253 3.30027 10.5595 3.18306 10.4423C3.06585 10.3251 3 10.1661 3 10.0003C3 9.83459 3.06585 9.67562 3.18306 9.55841C3.30027 9.4412 3.45924 9.37535 3.625 9.37535H15.8664L11.3078 4.81753C11.1905 4.70026 11.1247 4.5412 11.1247 4.37535C11.1247 4.2095 11.1905 4.05044 11.3078 3.93316C11.4251 3.81588 11.5841 3.75 11.75 3.75C11.9159 3.75 12.0749 3.81588 12.1922 3.93316L17.8172 9.55816C17.8753 9.61621 17.9214 9.68514 17.9529 9.76101C17.9843 9.83688 18.0005 9.91821 18.0005 10.0003C18.0005 10.0825 17.9843 10.1638 17.9529 10.2397C17.9214 10.3156 17.8753 10.3845 17.8172 10.4425Z" fill="white" />
                        //     </svg>
                        // }
                        sx={{
                            height: "48px",
                            width: "340px",
                            backgroundColor: PRIMARY.P_BLue,
                        }}
                    >Save</Button>
                </div>

            </>
        )
    }

    const RecurringSchedulingDetailComponent: React.FC<{ setRefresh: Dispatch<SetStateAction<boolean>> }> = ({ setRefresh }) => {
        const navigate = useNavigate();
        type WeeksObject = {
            "0": boolean,
            "1": boolean,
            "2": boolean,
            "3": boolean,
            "4": boolean,
            "5": boolean,
            "6": boolean,
        }
        type HourAndMin = {
            hour: string;
            min: string;
        }
        const [oneTimeHourAndMin, setOneTimeHourAndMin] = useState<HourAndMin>({} as HourAndMin);
        const [emails, setEmails] = useState<string>("");

        const [state, setState] = useState<StateObject>({
            start_time_stamp: getUTC(new Date()),
            end_time_stamp: getUTC(new Date()),
            time_slots: { type: '', week_days: [], time_slots: [] },
            emails: []
        });
        const [loading, setLoading] = useState<boolean>(false);
        const [selectedWeeks, setSelectedWeeks] = useState<WeeksObject>({
            "0": false,
            "1": false,
            "2": false,
            "3": false,
            "4": false,
            "5": false,
            "6": false,
        });
        const [daysDisabled, setDaysDisabled] = useState<boolean>(true);
        const [timeSlot, setTimeSlot] = useState<Set<string>>(new Set());
        const [confirm, setConfirm] = useState<boolean>(false);
        const setHourAndMinHandler = (unit: string, value: string) => {

            setOneTimeHourAndMin(prevState => ({
                ...prevState,
                [unit]: value
            }))
        }

        const weeks = useMemo(() => [
            { name: "0", label: "S" }, { name: "1", label: "M" }, { name: "2", label: "T" }, { name: "3", label: "W" }, { name: "4", label: "T" }, { name: "5", label: "F" }, { name: "6", label: "S" }
        ], []);

        const onAddTimeClick = () => {
            setTimeSlot(prevState => {
                const generateKey = (hm: HourAndMin) => `${hm.hour} : ${hm.min}`;
                let key = generateKey(oneTimeHourAndMin);
                if (prevState.has(key)) {
                    appError("Time already added.");
                } else {
                    prevState.add(key);
                    setOneTimeHourAndMin({} as HourAndMin);
                }
                return prevState;
            });
        }

        const onDeleteTimeSlot = (id: string) => {
            setTimeSlot(prevState => {
                if (prevState.has(id)) {
                    prevState.delete(id);
                }
                return new Set(prevState);
            });
        }



        const onDateChangeHandler = (dateObje: Dayjs | null, name: string) => {

            const date = dateObje?.date();
            const month = dateObje?.month();
            const year = dateObje?.year();
            const time_stamp = new Date(`${year}-${(month as number + 1)}-${date}`);
            setState(prevState => ({
                ...prevState,
                [name]: time_stamp,
            }));
        }


        const onSelectFrequencyHandler = (event: any, value: any) => {
            setState(prevState => ({ ...prevState, time_slots: { ...prevState.time_slots, type: value } }));
            if (value === "daily") {
                setSelectedWeeks({
                    "0": false,
                    "1": false,
                    "2": false,
                    "3": false,
                    "4": false,
                    "5": false,
                    "6": false,
                });
                setDaysDisabled(true);
            } else if (value === "weekly") {
                setSelectedWeeks({
                    "0": false,
                    "1": true,
                    "2": true,
                    "3": true,
                    "4": true,
                    "5": true,
                    "6": false,

                });
                setDaysDisabled(false);
            }

        }

        const onWeekDayClickHandler = (index: string) => {
            setSelectedWeeks(prevState => {
                const state = structuredClone(prevState);
                if (state[index as keyof WeeksObject]) {
                    state[index as keyof WeeksObject] = false;
                } else {
                    state[index as keyof WeeksObject] = true;
                }
                return { ...state }
            })
        }


        const onInputChangeHandler = ({ target: { name, value } }: ChangeEvent<HTMLInputElement>) => {
            setEmails(value);
        }


        const onSaveClickHandler = async (confirm: boolean) => {

            const obj: StateObject = state;

            const { type } = state?.time_slots;
            if (!type) {
                appError("Please select frequency");
                return;
            }

            if (type === "daily") {
                obj.time_slots.week_days = [0, 1, 2, 3, 4, 5, 6]
            } else {
                let week_days = [];
                for (let key in selectedWeeks) {
                    if (selectedWeeks[key as keyof WeeksObject]) {
                        week_days.push(parseInt(key));
                    }
                }
                obj.time_slots.week_days = week_days;
            }

            if (!obj.time_slots.week_days.length) {
                appError("Please select week week_days.");
                return
            }

            // if (!timeSlot.size) {
            //     appError("Please select time slot.");
            //     return;
            // }

            if (!(oneTimeHourAndMin.hour && oneTimeHourAndMin.min)) {
                appError("Please select time slot.");
                return;
            }


            // let timeSlotArray: string[] = []
            // for (let [el] of timeSlot.entries()) {
            //     let [hour, min] = el.split(":");
            //     timeSlotArray.push(`${hour.trim()}:${min.trim()}`);
            // }

            if (!emails.length) {
                appError("Please provide email.");
                return
            }


            const { schedule_name, schedule_type, file_name, file_id, profile_obj } = fileDetail;
            const { start_time_stamp, end_time_stamp, time_slots: { week_days } } = state;


            const objTwo = {
                schedule_name,
                file_name,
                file_id,
                start_date: getDateString(start_time_stamp),
                end_date: getDateString(end_time_stamp),
                today_current_date: getDateString(new Date()),
                today_current_time: getTimeString(new Date()),
                emails: emails,
                time_slots: {
                    recurring_type: type,
                    type: schedule_type,
                    time_slots: [`${oneTimeHourAndMin.hour}:${oneTimeHourAndMin.min}`],  //timeSlotArray,
                    week_days
                },
                profile_obj
            }



            if (confirm) {
                let current_date_time_plus_one_hour = new Date(`${getDateString(new Date())}T${getTimeString(new Date())}`);
                current_date_time_plus_one_hour.setHours(current_date_time_plus_one_hour.getHours() + 1);
                let schedule_date_time = new Date(`${objTwo.start_date}T${objTwo.time_slots?.time_slots[0]}`);

                if (!(schedule_date_time > current_date_time_plus_one_hour)) {
                    // appError("Please choose a time at least 1 hour from the current time.");
                    setConfirm(true);
                    return;
                }
            }



            if (!(new Date(objTwo.end_date).getTime() >= new Date(objTwo.start_date).getTime())) {
                appError("End Date should be greater or equal to Start Date.");
                return;
            }

            try {
                setLoading(true);
                const token = localStorage.getItem("token");

                const res = await axios.post(`${BASE_URL}brand/bulk/fileDetail?brand_id=${brandId}&platform_id=${platform_id}&dashboard_type_id=${brand_power_bi_dashboard_type_id}`,
                    objTwo,
                    {
                        headers: {
                            "Authorization": `Bearer ${token}`
                        }
                    }
                );

                const { message, file_detail_id } = res?.data?.data;
                toast.success(message);
                setOpenModal(false);
                setRefresh(prevState => !prevState);
                navigate("/bulkUpload/allFiles");
            } catch (error) {
                appError(error);
            } finally {
                setLoading(false);
            }
        }

        const toggleDisabled: boolean = Boolean(oneTimeHourAndMin?.hour && oneTimeHourAndMin?.min);
        const timeSlotArray = Array.from(timeSlot);
        return (
            <>

                {
                    confirm ? (
                        <>
                            <div className="flex justify-center" >
                                <svg xmlns="http://www.w3.org/2000/svg" width="250" height="250" viewBox="0 0 250 250" fill="none">
                                    <path d="M48.6301 214.725C91.6601 237.225 161.43 237.225 204.46 214.725C247.49 192.225 247.49 155.795 204.46 133.315C161.43 110.835 91.6601 110.815 48.6301 133.315C5.60009 155.815 5.59509 192.25 48.6301 214.725Z" fill="#F5F5F5" />
                                    <path d="M177.33 194.32C188.621 194.32 197.775 189.035 197.775 182.515C197.775 175.995 188.621 170.71 177.33 170.71C166.039 170.71 156.885 175.995 156.885 182.515C156.885 189.035 166.039 194.32 177.33 194.32Z" fill="#E0E0E0" />
                                    <path d="M52.7999 176.35C52.4949 172.88 49.3599 165.915 45.3649 161.725C41.3699 157.535 35.4249 154.725 31.5249 156.46C27.8899 158.07 28.7249 162.96 33.5549 165.805C38.3849 168.65 45.5549 172.155 48.0549 177.61L52.8499 184.15L52.7999 176.35Z" fill="#FF8831" />
                                    <path opacity="0.1" d="M52.7999 176.35C52.4949 172.88 49.3599 165.915 45.3649 161.725C41.3699 157.535 35.4249 154.725 31.5249 156.46C27.8899 158.07 28.7249 162.96 33.5549 165.805C38.3849 168.65 45.5549 172.155 48.0549 177.61L52.8499 184.15L52.7999 176.35Z" fill="black" />
                                    <path d="M53.47 181.075C53.4141 181.077 53.3594 181.059 53.3149 181.026C53.2703 180.992 53.2386 180.944 53.2249 180.89C49.8649 169.25 39.445 160.465 33.525 158.835C33.4921 158.826 33.4614 158.811 33.4344 158.79C33.4075 158.77 33.3849 158.744 33.3679 158.714C33.351 158.685 33.34 158.652 33.3356 158.618C33.3313 158.585 33.3336 158.55 33.3424 158.518C33.3513 158.485 33.3666 158.454 33.3873 158.427C33.4081 158.4 33.4339 158.378 33.4634 158.361C33.4929 158.344 33.5254 158.333 33.5591 158.328C33.5929 158.324 33.6271 158.326 33.6599 158.335C39.6899 159.995 50.3049 168.925 53.7099 180.74C53.7199 180.772 53.7234 180.805 53.7202 180.839C53.717 180.872 53.7072 180.904 53.6913 180.933C53.6755 180.963 53.6539 180.989 53.6279 181.01C53.6019 181.03 53.572 181.046 53.54 181.055L53.47 181.075Z" fill="white" />
                                    <path d="M52.365 188.81C51.635 186.91 48.975 183.9 44.865 181.575C40.365 179.01 34.835 178.13 33.365 175.945C31.63 173.33 33.725 170.53 38.15 170.69C42.575 170.85 50.79 176.15 52.81 185.035L52.365 188.81Z" fill="#FF8831" />
                                    <path d="M53.0348 186.69C52.9853 186.691 52.9367 186.677 52.895 186.65C52.8533 186.624 52.8202 186.585 52.7998 186.54C48.2998 176.715 40.2298 173.83 36.6048 173.675C36.5713 173.674 36.5384 173.666 36.508 173.652C36.4775 173.638 36.4501 173.618 36.4274 173.594C36.4046 173.569 36.3869 173.54 36.3754 173.509C36.3638 173.477 36.3585 173.444 36.3598 173.41C36.3604 173.377 36.3678 173.344 36.3817 173.313C36.3955 173.283 36.4155 173.255 36.4403 173.233C36.4652 173.21 36.4943 173.193 36.5261 173.182C36.5578 173.172 36.5914 173.168 36.6248 173.17C40.6248 173.335 48.6248 176.295 53.2648 186.33C53.2908 186.391 53.2923 186.46 53.269 186.523C53.2458 186.585 53.1996 186.636 53.1398 186.665C53.1069 186.681 53.0711 186.689 53.0348 186.69Z" fill="white" />
                                    <path d="M188.585 171.855C188.51 169.06 189.285 164.38 192.035 159.705C194.98 154.705 198.865 151.355 202.13 152.375C205.17 153.325 204.5 157.45 199.93 161.945C196.72 165.1 193.5 169.1 192 173.675L189.43 179.565L188.585 171.855Z" fill="#FF8831" />
                                    <path d="M188.585 171.855C188.51 169.06 189.285 164.38 192.035 159.705C194.98 154.705 198.865 151.355 202.13 152.375C205.17 153.325 204.5 157.45 199.93 161.945C196.72 165.1 193.5 169.1 192 173.675L189.43 179.565L188.585 171.855Z" fill="#FF8831" />
                                    <g opacity="0.1">
                                        <path d="M188.585 171.855C188.51 169.06 189.285 164.38 192.035 159.705C194.98 154.705 198.865 151.355 202.13 152.375C205.17 153.325 204.5 157.45 199.93 161.945C196.72 165.1 193.5 169.1 192 173.675L189.43 179.565L188.585 171.855Z" fill="black" />
                                    </g>
                                    <path d="M189.095 173.93C189.136 173.927 189.174 173.91 189.205 173.883C189.235 173.856 189.256 173.82 189.265 173.78C191.225 165.81 196.185 157.42 200.81 154.28C200.846 154.248 200.87 154.204 200.876 154.156C200.883 154.108 200.872 154.059 200.845 154.019C200.818 153.978 200.777 153.949 200.73 153.937C200.683 153.924 200.633 153.929 200.59 153.95C195.895 157.155 190.86 165.64 188.88 173.7C188.874 173.725 188.873 173.751 188.877 173.776C188.881 173.802 188.89 173.826 188.904 173.848C188.917 173.87 188.935 173.889 188.955 173.904C188.976 173.919 189 173.929 189.025 173.935C189.048 173.939 189.072 173.937 189.095 173.93Z" fill="white" />
                                    <path d="M188.56 180.89C190.103 182.259 191.979 183.197 194 183.61C197.5 184.375 199.13 182.79 199.13 182.79C199.13 182.79 197.94 179.415 196.005 178.37C198.134 178.982 200.144 179.951 201.95 181.235C201.95 181.235 204.09 181.395 205.14 178.175C205.14 178.175 203.985 176.125 199.785 174.81C201.912 174.557 204.068 174.793 206.09 175.5C206.365 175.63 207.81 171.47 208.29 169.54C208.77 167.61 207.98 167.58 206.485 167.085C204.99 166.59 199.815 166.025 198.815 166.805C197.815 167.585 197.155 170.415 197.155 170.415C197.155 170.415 196.34 168.745 196.655 167.31C195.612 166.943 194.481 166.903 193.415 167.195C191.67 167.695 191.73 168.53 191.655 169.775C191.574 171.027 191.672 172.285 191.945 173.51C191.945 173.51 190.825 172.415 191.01 168.645C191.01 168.645 188.58 170.485 187.55 172.145C186.52 173.805 186.5 178.22 188.56 180.89Z" fill="#FF8831" />
                                    <path d="M188.545 181.09C188.582 181.092 188.619 181.084 188.652 181.067C188.684 181.049 188.711 181.022 188.73 180.99C191.915 175.27 202.86 169.055 206.68 168.545C206.705 168.542 206.73 168.533 206.752 168.52C206.775 168.507 206.794 168.489 206.81 168.469C206.825 168.448 206.837 168.425 206.843 168.399C206.85 168.374 206.851 168.348 206.847 168.323C206.844 168.297 206.835 168.272 206.822 168.25C206.809 168.228 206.791 168.208 206.771 168.193C206.75 168.177 206.727 168.166 206.702 168.16C206.677 168.153 206.65 168.152 206.625 168.155C202.745 168.655 191.625 174.985 188.385 180.795C188.359 180.841 188.353 180.895 188.367 180.946C188.381 180.996 188.414 181.039 188.46 181.065C188.486 181.08 188.515 181.089 188.545 181.09Z" fill="white" />
                                    <path d="M55.4999 192.64L54.1399 191.855C53.5575 191.475 53.0729 190.964 52.7254 190.362C52.3779 189.759 52.1773 189.084 52.1399 188.39V69.1448C52.1769 68.4499 52.3773 67.7735 52.7248 67.1706C53.0723 66.5676 53.5572 66.0552 54.1399 65.6748L109.14 33.9248C109.76 33.6099 110.445 33.4458 111.14 33.4458C111.835 33.4458 112.52 33.6099 113.14 33.9248L114.5 34.7098C115.082 35.0897 115.566 35.6013 115.914 36.2033C116.261 36.8053 116.462 37.4807 116.5 38.1748V157.425C116.462 158.119 116.261 158.794 115.914 159.396C115.566 159.998 115.082 160.51 114.5 160.89L59.4999 192.64C58.8802 192.955 58.195 193.119 57.4999 193.119C56.8048 193.119 56.1196 192.955 55.4999 192.64Z" fill="#37474F" />
                                    <path d="M60.1849 71.4998L52.7249 67.1948C52.366 67.7931 52.1647 68.4726 52.1399 69.1698V188.39C52.1773 189.084 52.3779 189.76 52.7254 190.362C53.0729 190.964 53.5575 191.475 54.1399 191.855L55.4999 192.64C56.1196 192.955 56.8048 193.119 57.4999 193.119C58.195 193.119 58.8802 192.955 59.4999 192.64L60.1799 192.25L60.1849 71.4998Z" fill="#263238" />
                                    <path d="M57.5 72.2399V191.5C57.5 192.78 58.395 193.295 59.5 192.655L114.5 160.905C115.082 160.525 115.566 160.013 115.914 159.411C116.261 158.809 116.462 158.134 116.5 157.44V38.1749C116.5 36.8999 115.605 36.3849 114.5 37.0199L59.5 68.7749C58.9171 69.1539 58.432 69.6653 58.0845 70.2675C57.7369 70.8697 57.5366 71.5455 57.5 72.2399Z" fill="#455A64" />
                                    <path d="M61.8998 79.7799L111.9 50.9049C112.845 50.3599 113.615 50.8049 113.615 51.9049V147.03C113.583 147.625 113.41 148.204 113.112 148.72C112.814 149.236 112.399 149.675 111.9 150L61.8998 178.87C60.9498 179.42 60.1848 178.975 60.1848 177.87V82.7499C60.2159 82.1546 60.3875 81.5751 60.6856 81.0589C60.9837 80.5427 61.3998 80.1044 61.8998 79.7799Z" fill="#FAFAFA" />
                                    <g opacity="0.4">
                                        <path d="M87.18 87.2748C92.785 84.0398 97.33 86.6648 97.33 93.1348C97.33 99.6048 92.785 107.485 87.18 110.72C81.575 113.955 77.03 111.335 77.03 104.86C77.03 98.3848 81.575 90.4998 87.18 87.2748Z" fill="#FF8831" />
                                        <path d="M107.185 121.9C107.185 111.265 99.72 106.54 90.51 111.86L84.75 115.185C75.54 120.5 68.075 133.435 68.075 144.07V146.935L107.185 124.365V121.9Z" fill="#FF8831" />
                                    </g>
                                    <path d="M86.9999 55.9999C87.7399 55.5699 88.3399 55.9199 88.3399 56.7749C88.3151 57.2399 88.1808 57.6923 87.9479 58.0955C87.7151 58.4987 87.3902 58.8411 86.9999 59.0949C86.2599 59.5249 85.6599 59.1749 85.6599 58.3199C85.6847 57.855 85.819 57.4025 86.0519 56.9993C86.2847 56.5962 86.6096 56.2537 86.9999 55.9999Z" fill="#263238" />
                                    <path d="M83.1298 62.6896C85.8548 61.1896 90.7148 58.2946 93.3998 56.7146C93.8548 56.4446 94.2248 56.6296 94.2248 57.1246C94.205 57.4038 94.1195 57.6743 93.9753 57.9141C93.831 58.154 93.6321 58.3563 93.3948 58.5046L83.1098 64.4446C82.6498 64.7096 82.2798 64.5246 82.2798 64.0246C82.303 63.7499 82.3925 63.485 82.5405 63.2525C82.6885 63.02 82.8907 62.8268 83.1298 62.6896Z" fill="#263238" />
                                    <path d="M80.5299 64.195C80.9449 63.955 81.2849 64.15 81.2849 64.63C81.2702 64.8915 81.1942 65.1458 81.063 65.3725C80.9319 65.5992 80.7493 65.7919 80.5299 65.935C80.1149 66.175 79.7749 65.98 79.7749 65.5C79.7896 65.2385 79.8656 64.9841 79.9967 64.7574C80.1279 64.5308 80.3105 64.3381 80.5299 64.195Z" fill="#263238" />
                                    <path d="M86.9998 167.5C88.4998 166.645 89.6848 167.34 89.6848 169.05C89.6347 169.981 89.3653 170.887 88.8987 171.694C88.4322 172.501 87.7815 173.187 86.9998 173.695C85.4998 174.55 84.3198 173.855 84.3198 172.145C84.3702 171.214 84.6391 170.309 85.1048 169.502C85.5704 168.695 86.2196 168.009 86.9998 167.5Z" fill="#263238" />
                                    <path d="M132.605 134.07L126.575 130.57L126.51 130.535C123.51 128.845 119.4 129.09 114.845 131.725C110.585 134.18 106.695 138.275 103.765 143.02C100.38 148.48 98.2649 154.805 98.2649 160.47C98.2649 165.755 100.115 169.47 103.105 171.205L109.23 174.705C112.255 176.635 116.52 176.46 121.26 173.73C130.415 168.5 137.85 155.605 137.85 145C137.85 139.5 135.83 135.705 132.605 134.07Z" fill="#FF8831" />
                                    <path opacity="0.1" d="M109.1 174.675L103.1 171.245C100.1 169.51 98.26 165.795 98.26 160.51C98.26 154.84 100.39 148.51 103.76 143.06L110.17 146.755C106.78 152.22 104.67 158.53 104.67 164.19C104.645 169.235 106.34 172.85 109.1 174.675Z" fill="black" />
                                    <path opacity="0.4" d="M132.5 134C129.54 132.565 125.595 132.93 121.265 135.425C116.935 137.92 113.095 142 110.16 146.745L103.75 143.05C106.68 138.305 110.57 134.21 114.83 131.755C119.38 129.125 123.495 128.875 126.495 130.565L126.56 130.6L132.5 134Z" fill="white" />
                                    <path d="M129.895 140.75L127.595 139.42L118.59 160.645L120.125 161.53L129.895 140.75Z" fill="white" />
                                    <path d="M116.825 155.905L114.525 154.58L112.055 159.805L114.355 161.13L116.825 155.905Z" fill="white" />
                                    <path d="M120.715 167.755L114.355 161.13L116.825 155.905L120.125 161.53L129.895 140.75L133.515 144.28L120.715 167.755Z" fill="#F5F5F5" />
                                    <path d="M112.055 159.805L114.355 161.13L120.715 167.755L118.42 166.44L112.055 159.805Z" fill="#E0E0E0" />
                                    <path d="M179.5 81.9599C182.104 81.9599 184.602 80.9253 186.444 79.0836C188.285 77.242 189.32 74.7443 189.32 72.1399V71.5599C189.32 70.4668 189.106 69.3844 188.688 68.3744C188.27 67.3644 187.657 66.4466 186.885 65.6735C186.112 64.9004 185.195 64.2871 184.185 63.8687C183.175 63.4502 182.093 63.2349 181 63.2349H178C175.792 63.2349 173.674 64.112 172.113 65.6732C170.552 67.2344 169.675 69.3519 169.675 71.5599V72.1399C169.675 73.4299 169.929 74.7072 170.423 75.899C170.917 77.0907 171.64 78.1735 172.553 79.0854C173.465 79.9974 174.548 80.7206 175.74 81.2138C176.932 81.707 178.21 81.9605 179.5 81.9599Z" fill="#263238" />
                                    <path d="M169.37 179.095C168.225 180.297 166.969 181.388 165.62 182.355C165.414 182.493 165.243 182.676 165.12 182.89C164.945 183.26 164.67 184.17 166.345 184.755C167.192 185.049 168.092 185.156 168.985 185.07C169.877 184.983 170.74 184.705 171.515 184.255C172.895 183.395 172.955 181.605 174.255 180.58C175.215 179.825 176.415 179.63 177.195 178.64C177.735 177.95 177.595 177.035 177.31 175.9C177.005 174.66 176.86 173.725 176.45 173.82L176.52 174.39C176.02 175.205 173.355 175.445 172.175 174.89C172.155 174.88 170.115 178.28 169.37 179.095Z" fill="#263238" />
                                    <path d="M168.205 180.25C168.605 179.885 168.995 179.505 169.37 179.095C170.155 178.076 170.878 177.011 171.535 175.905C171.988 175.235 172.201 174.431 172.14 173.625C172.045 172.765 171.81 170.57 171.81 170.57L176.01 170.27L176.51 174.39C176.61 175.325 175.84 176.155 174.47 177.335C173.1 178.515 171.37 181.26 170.13 181.95C168.89 182.64 168.01 182.615 167.48 182.26C166.95 181.905 166.875 181.615 168.205 180.25Z" fill="#B16668" />
                                    <path d="M185.345 179.47V178.835C185.1 179.58 183.945 182.765 182.19 184.365C180.8 185.635 178.9 187.1 178.415 188.52C177.93 189.94 181.06 190.485 182.36 190.255C183.86 189.99 185.83 189.13 186.895 187.825C187.64 186.905 188.12 185.825 188.655 185.09C189.19 184.355 190.42 183.56 190.71 182.72C190.87 182.26 190.68 181.255 190.455 180.405C190.23 179.555 190.03 178.765 189.765 178.835V179.335C189.135 179.829 188.355 180.092 187.555 180.08C186.91 180.09 185.34 179.96 185.345 179.47Z" fill="#263238" />
                                    <path d="M180.93 185.5C181.36 185.115 181.795 184.74 182.19 184.38C183.415 183.265 184.35 181.38 184.885 180.08C185.191 179.343 185.349 178.553 185.35 177.755V175.255H189.765V179.355V179.465C189.555 180.385 187.525 182.825 186.375 184.415C185.605 185.48 184.14 186.84 182.375 187.075C180.7 187.265 179.85 186.74 180.93 185.5Z" fill="#B16668" />
                                    <path d="M188.885 110.84C192.31 118.315 188.76 144.655 188.76 144.655C188.865 145.87 190.26 148.26 190.76 153.6C191.37 159.91 189.8 175.75 189.8 175.75C189.127 176.142 188.368 176.363 187.59 176.394C186.811 176.426 186.037 176.266 185.335 175.93C185.335 175.93 181.13 152.065 180.335 145.795C179.645 140.32 178.335 127.45 178.335 127.45L174.895 145.91C175.531 147.637 175.982 149.427 176.24 151.25C176.595 154.945 176.33 172.01 176.33 172.01C176.33 172.01 174.83 173.16 171.925 172.735C171.925 172.735 166.925 149.365 166.53 144.925C166.3 142.275 169.32 109.745 169.32 109.745L188.885 110.84Z" fill="#FF8831" />
                                    <path opacity="0.6" d="M188.885 110.84C192.31 118.315 188.76 144.655 188.76 144.655C188.865 145.87 190.26 148.26 190.76 153.6C191.37 159.91 189.8 175.75 189.8 175.75C189.127 176.142 188.368 176.363 187.59 176.394C186.811 176.426 186.037 176.266 185.335 175.93C185.335 175.93 181.13 152.065 180.335 145.795C179.645 140.32 178.335 127.45 178.335 127.45L174.895 145.91C175.531 147.637 175.982 149.427 176.24 151.25C176.595 154.945 176.33 172.01 176.33 172.01C176.33 172.01 174.83 173.16 171.925 172.735C171.925 172.735 166.925 149.365 166.53 144.925C166.3 142.275 169.32 109.745 169.32 109.745L188.885 110.84Z" fill="black" />
                                    <path opacity="0.3" d="M178.33 127.45L177.22 121.335C177.22 121.335 172.515 120.36 170.385 118.335C170.385 118.335 172.62 121.12 175.945 122.03L177.195 127.375L175.23 144.075L178.33 127.45Z" fill="black" />
                                    <path d="M194.465 107.59C194.43 107.09 193.51 101.865 192.88 98.9351L186.725 100.82L187.82 106.21L193 110.37C194.63 110.05 194.5 108.08 194.465 107.59Z" fill="#B16668" />
                                    <path d="M164.695 96.5498L161.785 101.885L166.315 105.765L170.46 99.1898L164.695 96.5498Z" fill="#B16668" />
                                    <path d="M175.615 84.665C172.73 84.695 169.55 85.74 168.455 88.005C167.36 90.27 164.335 96.505 164.335 96.505C164.335 96.505 167.03 100.165 171.075 99.9L175.615 84.665Z" fill="#FF8831" />
                                    <path opacity="0.6" d="M175.615 84.665C172.73 84.695 169.55 85.74 168.455 88.005C167.36 90.27 164.335 96.505 164.335 96.505C164.335 96.505 167.03 100.165 171.075 99.9L175.615 84.665Z" fill="black" />
                                    <path d="M181.585 84.765L183.99 84.865C186.6 85.49 187.545 87.285 188.64 89.6C189.443 91.3877 189.518 93.4178 188.85 95.26L185.79 104.11C185.79 104.11 187.22 107.57 188.885 110.84C181.21 115.125 171.625 112.87 169.315 109.745C169.22 109.08 169.35 106.095 169.165 102.695C168.97 99.065 168.47 94.97 169.04 92.73C170.1 88.57 172.08 84.665 176.04 84.665L181.585 84.765Z" fill="#F5F5F5" />
                                    <path d="M184 84.8647C186.615 85.2347 190.465 85.7597 191.79 91.9847C193.135 98.2947 193.39 99.7998 193.39 99.7998C193.39 99.7998 191.1 102.085 186.755 102.065C186.745 102.065 182.915 89.6747 184 84.8647Z" fill="#FF8831" />
                                    <path opacity="0.6" d="M184 84.8647C186.615 85.2347 190.465 85.7597 191.79 91.9847C193.135 98.2947 193.39 99.7998 193.39 99.7998C193.39 99.7998 191.1 102.085 186.755 102.065C186.745 102.065 182.915 89.6747 184 84.8647Z" fill="black" />
                                    <path d="M186.63 101.68C186.13 100.025 185.63 98.135 185.155 96.105C185.175 98.657 185.435 101.201 185.93 103.705L186.63 101.68Z" fill="#EBEBEB" />
                                    <path d="M172.88 67.2051C171.845 67.8201 170.565 70.4301 170.69 75.9001C170.795 80.5351 172.3 81.6801 173.055 82.0101C173.81 82.3401 175.265 82.1401 176.68 81.9051V84.6901C176.68 84.6901 174.725 86.9601 174.845 88.2351C174.965 89.5101 177.67 89.8151 179.5 88.5651C180.685 87.712 181.702 86.6475 182.5 85.4251V78.6951C182.5 78.6951 183.455 79.9701 185 78.9351C186.545 77.9001 186.62 75.3301 185.715 74.4051C184.81 73.4801 182.845 73.7751 182.485 75.0501C182.485 75.0501 180.225 75.1351 177.22 73.4851C176.055 72.852 175.055 71.9537 174.301 70.8628C173.547 69.7718 173.06 68.5189 172.88 67.2051Z" fill="#B16668" />
                                    <path d="M175.865 74.735C175.863 74.8498 175.895 74.9626 175.957 75.0593C176.019 75.1561 176.108 75.2325 176.213 75.279C176.318 75.3256 176.434 75.3402 176.547 75.3211C176.66 75.302 176.765 75.25 176.849 75.1716C176.933 75.0931 176.992 74.9918 177.019 74.8801C177.045 74.7684 177.039 74.6514 176.999 74.5435C176.96 74.4357 176.89 74.3418 176.797 74.2736C176.705 74.2054 176.594 74.1659 176.48 74.16C176.402 74.1573 176.324 74.1701 176.251 74.1976C176.177 74.225 176.11 74.2666 176.053 74.32C175.996 74.3734 175.95 74.4376 175.918 74.5088C175.885 74.58 175.867 74.6569 175.865 74.735Z" fill="#263238" />
                                    <path d="M175.71 78.665L174.355 79.1C174.378 79.1918 174.419 79.2779 174.477 79.3532C174.534 79.4285 174.606 79.4914 174.688 79.5382C174.77 79.5849 174.861 79.6145 174.955 79.6251C175.049 79.6357 175.144 79.6272 175.235 79.6C175.421 79.5372 175.574 79.4041 175.663 79.2294C175.752 79.0546 175.769 78.852 175.71 78.665Z" fill="#9A4A4D" />
                                    <path d="M171.085 72.9446L172.265 72.1296C172.216 72.047 172.15 71.9755 172.072 71.9198C171.993 71.8641 171.904 71.8253 171.81 71.806C171.716 71.7867 171.619 71.7873 171.525 71.8077C171.431 71.8282 171.343 71.868 171.265 71.9246C171.111 72.0396 171.006 72.2093 170.972 72.3989C170.939 72.5885 170.979 72.7837 171.085 72.9446Z" fill="#263238" />
                                    <path d="M171.355 74.315C171.354 74.4296 171.387 74.5419 171.449 74.638C171.512 74.7341 171.601 74.8097 171.706 74.8555C171.811 74.9013 171.928 74.9152 172.04 74.8955C172.153 74.8758 172.258 74.8234 172.341 74.7448C172.425 74.6661 172.483 74.5648 172.509 74.4532C172.536 74.3416 172.529 74.2248 172.489 74.1173C172.449 74.0097 172.379 73.9161 172.287 73.8482C172.195 73.7802 172.084 73.7408 171.97 73.735C171.812 73.7322 171.659 73.7913 171.544 73.8997C171.429 74.0081 171.361 74.1571 171.355 74.315Z" fill="#263238" />
                                    <path d="M174.105 73.98L174.015 77.49L172.17 76.92L174.105 73.98Z" fill="#9A4A4D" />
                                    <path d="M176.68 81.9047C178.18 81.7097 181.235 80.8297 181.715 79.6147C181.524 80.2292 181.148 80.7702 180.64 81.1647C179.725 81.9497 176.68 82.8347 176.68 82.8347V81.9047Z" fill="#9A4A4D" />
                                    <path d="M152.275 96.2251L169.2 100.68L174.2 121.69L158.105 117.015L152.275 96.2251Z" fill="#FF8831" />
                                    <path opacity="0.15" d="M159.655 110.125C159.5 110.555 158.57 111.745 156.6 111.65L156.36 110.78L159.655 110.125Z" fill="black" />
                                    <path opacity="0.15" d="M163.44 110.78C163.515 111.34 164.665 112.38 166.61 113.025C168.825 113.765 172.22 113.375 172.22 113.375L171.915 112.33L163.44 110.78Z" fill="black" />
                                    <path opacity="0.15" d="M157.23 99.2648C157.23 99.2648 157.17 98.9748 157.09 98.6198C157.01 98.2648 158.01 98.2448 159.31 98.5848L161.81 99.2298C163.11 99.5698 164.23 100.135 164.31 100.49L164.45 101.135L157.23 99.2648Z" fill="black" />
                                    <path d="M156.06 96.8298C156.01 96.6048 156.41 96.5498 156.955 96.6998L157.955 96.9698C157.955 96.9698 157.66 95.5748 159.85 96.0648C162.04 96.5548 162.52 98.1348 162.52 98.1348L163.575 98.4348C164.16 98.5998 164.685 98.9348 164.755 99.1398L164.88 99.5398L156.16 97.2448C156.16 97.2448 156.105 97.0498 156.06 96.8298Z" fill="#37474F" />
                                    <path d="M157.26 97.5248C158.06 97.7198 158.39 97.8248 158.51 98.3748C158.645 99.0048 158.7 99.4648 158.7 99.4648L162.56 100.465C162.56 100.465 162.375 99.6698 162.315 99.3598C162.255 99.0498 162.385 98.8598 163 99.0248L163.05 98.7798L157 97.2598L157.26 97.5248Z" fill="#37474F" />
                                    <path d="M157.125 99.3249C157.125 99.3249 157.065 99.0349 156.985 98.6799C156.905 98.3249 157.905 98.3099 159.205 98.6449L161.705 99.2949C163.005 99.6299 164.125 100.195 164.205 100.55L164.345 101.195L157.125 99.3249Z" fill="#37474F" />
                                    <path d="M193 110.37L187.815 106.21C187.815 106.21 176.355 108.25 175.005 108.355C174.293 108.374 173.591 108.178 172.993 107.792C172.394 107.405 171.926 106.847 171.65 106.19C171.15 104.865 170.235 105.03 170.235 105.03C170.235 105.03 170.63 106.705 170.735 107.24C170.84 107.775 167.635 108.24 165.845 107.61C164.055 106.98 161.46 107.885 163.065 110.32C164.67 112.755 167.795 113.04 169.96 113.04C170.868 113.033 171.774 112.973 172.675 112.86C173.375 112.77 174.075 112.7 174.78 112.65C179.245 112.33 191 111 193 110.37Z" fill="#B16668" />
                                    <path d="M154 102.365L154.75 105.045C154.895 105.545 156.86 106.495 158.105 106.84C159.35 107.185 160.71 107.585 160.105 109.34C159.565 110.945 157.515 111.31 156.475 111.265C155.435 111.22 154.005 110.225 153.445 108.62C152.725 106.57 153.11 104.38 152.825 103.185C152.54 101.99 153.375 101.65 154 102.365Z" fill="#B16668" />
                                    <path d="M188.07 92.7301C187.339 92.7308 186.615 92.5873 185.939 92.3079C185.263 92.0285 184.649 91.6187 184.132 91.1019C183.614 90.5851 183.204 89.9714 182.924 89.2959C182.644 88.6204 182.5 87.8963 182.5 87.1651V79.3501C183.976 79.3514 185.39 79.9382 186.434 80.9815C187.477 82.0249 188.064 83.4396 188.065 84.9151L188.07 92.7301Z" fill="#263238" />
                                </svg>


                            </div>
                            <div className="flex justify-center mt-6" style={{ fontSize: 24, fontWeight: 500, lineHeight: "30px" }} >
                                Scheduling Confirmation
                            </div>
                            <div style={{ fontSize: "14px", fontWeight: 400, lineHeight: "20px", color: BLACK.B_40 }} className="text-center" >
                                Today’s <b>{oneTimeHourAndMin.hour}:{oneTimeHourAndMin.min} schedules won’t be auto-set</b> as it’s less than 1 hour away. All other schedules will be auto-scheduled as planned, including future  {oneTimeHourAndMin.hour}:{oneTimeHourAndMin.min} times.
                            </div>
                            <div className="flex flex-row justify-between mt-10">
                                <Button color="neutral"
                                    sx={{
                                        height: "48px",
                                        width: "340px",
                                        backgroundColor: BLACK.B_5,
                                        color: BLACK.B_100,
                                        ":hover": {
                                            backgroundColor: BLACK.B_20,
                                        }
                                    }}
                                    onClick={() => setConfirm(false)}
                                >Back to edit</Button>
                                <Button
                                    loading={loading}
                                    // onClick={onSaveClickHandler}
                                    // endDecorator={
                                    //     <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                    //         <path d="M17.8172 10.4425L12.1922 16.0675C12.0749 16.1848 11.9159 16.2507 11.75 16.2507C11.5841 16.2507 11.4251 16.1848 11.3078 16.0675C11.1905 15.9503 11.1247 15.7912 11.1247 15.6253C11.1247 15.4595 11.1905 15.3004 11.3078 15.1832L15.8664 10.6253H3.625C3.45924 10.6253 3.30027 10.5595 3.18306 10.4423C3.06585 10.3251 3 10.1661 3 10.0003C3 9.83459 3.06585 9.67562 3.18306 9.55841C3.30027 9.4412 3.45924 9.37535 3.625 9.37535H15.8664L11.3078 4.81753C11.1905 4.70026 11.1247 4.5412 11.1247 4.37535C11.1247 4.2095 11.1905 4.05044 11.3078 3.93316C11.4251 3.81588 11.5841 3.75 11.75 3.75C11.9159 3.75 12.0749 3.81588 12.1922 3.93316L17.8172 9.55816C17.8753 9.61621 17.9214 9.68514 17.9529 9.76101C17.9843 9.83688 18.0005 9.91821 18.0005 10.0003C18.0005 10.0825 17.9843 10.1638 17.9529 10.2397C17.9214 10.3156 17.8753 10.3845 17.8172 10.4425Z" fill="white" />
                                    //     </svg>
                                    // }
                                    sx={{
                                        height: "48px",
                                        width: "340px",
                                        backgroundColor: PRIMARY.P_BLue,
                                    }}
                                    onClick={() => onSaveClickHandler(false)}
                                >Proceed</Button>
                            </div>
                        </>
                    ) : (
                        <>

                            <div style={{ height: 46 }} className="flex flex-col justify-between" >
                                <div style={{ fontSize: 16, fontWeight: 600, color: BLACK.B_100 }}>Create New Bulk Scheduling</div>
                                <p style={{ fontSize: 12, fontWeight: 400, color: BLACK.B_40 }} >Add Bulk File here</p>
                            </div>

                            <div className="flex justify-between mt-6">
                                <div>
                                    <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_80 }}>Start Date</div>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                                        <DesktopDatePicker
                                            minDate={dayjs(new Date())}
                                            maxDate={dayjs(getNextMonthLastDate())}
                                            defaultValue={dayjs(new Date())}
                                            onChange={(e) => onDateChangeHandler(e, "start_time_stamp")}
                                            slots={{
                                                openPickerIcon: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M6.6665 11.6186C6.46248 11.6186 6.28859 11.5467 6.14484 11.4031C6.00123 11.2594 5.92942 11.0855 5.92942 10.8815C5.92942 10.6774 6.00123 10.5036 6.14484 10.3598C6.28859 10.2161 6.46248 10.1442 6.6665 10.1442C6.87053 10.1442 7.04442 10.2161 7.18817 10.3598C7.33178 10.5036 7.40359 10.6774 7.40359 10.8815C7.40359 11.0855 7.33178 11.2594 7.18817 11.4031C7.04442 11.5467 6.87053 11.6186 6.6665 11.6186ZM9.99984 11.6186C9.79581 11.6186 9.62192 11.5467 9.47817 11.4031C9.33456 11.2594 9.26275 11.0855 9.26275 10.8815C9.26275 10.6774 9.33456 10.5036 9.47817 10.3598C9.62192 10.2161 9.79581 10.1442 9.99984 10.1442C10.2039 10.1442 10.3778 10.2161 10.5215 10.3598C10.6651 10.5036 10.7369 10.6774 10.7369 10.8815C10.7369 11.0855 10.6651 11.2594 10.5215 11.4031C10.3778 11.5467 10.2039 11.6186 9.99984 11.6186ZM13.3332 11.6186C13.1291 11.6186 12.9553 11.5467 12.8115 11.4031C12.6679 11.2594 12.5961 11.0855 12.5961 10.8815C12.5961 10.6774 12.6679 10.5036 12.8115 10.3598C12.9553 10.2161 13.1291 10.1442 13.3332 10.1442C13.5372 10.1442 13.7111 10.2161 13.8548 10.3598C13.9984 10.5036 14.0703 10.6774 14.0703 10.8815C14.0703 11.0855 13.9984 11.2594 13.8548 11.4031C13.7111 11.5467 13.5372 11.6186 13.3332 11.6186ZM4.42296 17.9167C4.00199 17.9167 3.64567 17.7708 3.354 17.4792C3.06234 17.1875 2.9165 16.8312 2.9165 16.4102V5.25647C2.9165 4.8355 3.06234 4.47918 3.354 4.18751C3.64567 3.89585 4.00199 3.75001 4.42296 3.75001H5.57671V2.62814C5.57671 2.4455 5.63789 2.293 5.76025 2.17064C5.88261 2.04842 6.03511 1.9873 6.21775 1.9873C6.40053 1.9873 6.55303 2.04842 6.67525 2.17064C6.79762 2.293 6.8588 2.4455 6.8588 2.62814V3.75001H13.173V2.6123C13.173 2.43494 13.2328 2.2864 13.3523 2.16668C13.4721 2.0471 13.6206 1.9873 13.798 1.9873C13.9753 1.9873 14.1238 2.0471 14.2434 2.16668C14.3631 2.2864 14.423 2.43494 14.423 2.6123V3.75001H15.5767C15.9977 3.75001 16.354 3.89585 16.6457 4.18751C16.9373 4.47918 17.0832 4.8355 17.0832 5.25647V16.4102C17.0832 16.8312 16.9373 17.1875 16.6457 17.4792C16.354 17.7708 15.9977 17.9167 15.5767 17.9167H4.42296ZM4.42296 16.6667H15.5767C15.6409 16.6667 15.6996 16.6399 15.753 16.5865C15.8064 16.5331 15.8332 16.4744 15.8332 16.4102V8.5898H4.1665V16.4102C4.1665 16.4744 4.19324 16.5331 4.24671 16.5865C4.30005 16.6399 4.3588 16.6667 4.42296 16.6667ZM4.1665 7.3398H15.8332V5.25647C15.8332 5.1923 15.8064 5.13355 15.753 5.08022C15.6996 5.02675 15.6409 5.00001 15.5767 5.00001H4.42296C4.3588 5.00001 4.30005 5.02675 4.24671 5.08022C4.19324 5.13355 4.1665 5.1923 4.1665 5.25647V7.3398Z" fill="#1C1C1C" fill-opacity="0.4" />
                                                </svg>
                                            }}
                                            format="DD-MMM-YY"
                                            slotProps={{
                                                textField: {
                                                    placeholder: "Choose date",
                                                    sx: {

                                                        width: "340px",
                                                        '& .MuiInputBase-root': {
                                                            height: "52px"
                                                        },
                                                        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                                            border: `1px solid ${BLACK.B_10}`,
                                                            borderRadius: '8px'
                                                        },

                                                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                            border: `1px solid ${BLACK.B_10}`
                                                        },
                                                        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                                            border: `1px solid ${BLACK.B_10}`
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <div>
                                    <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_80 }}>End Date</div>
                                    <LocalizationProvider dateAdapter={AdapterDayjs} >
                                        <DesktopDatePicker
                                            minDate={dayjs(new Date().setDate(new Date().getDate() + 1))}
                                            maxDate={dayjs(getNextMonthLastDate())}
                                            defaultValue={dayjs(dayjs(new Date().setDate(new Date().getDate() + 1)))}
                                            onChange={(e) => onDateChangeHandler(e, "end_time_stamp")}
                                            slots={{
                                                openPickerIcon: () => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                    <path d="M6.6665 11.6186C6.46248 11.6186 6.28859 11.5467 6.14484 11.4031C6.00123 11.2594 5.92942 11.0855 5.92942 10.8815C5.92942 10.6774 6.00123 10.5036 6.14484 10.3598C6.28859 10.2161 6.46248 10.1442 6.6665 10.1442C6.87053 10.1442 7.04442 10.2161 7.18817 10.3598C7.33178 10.5036 7.40359 10.6774 7.40359 10.8815C7.40359 11.0855 7.33178 11.2594 7.18817 11.4031C7.04442 11.5467 6.87053 11.6186 6.6665 11.6186ZM9.99984 11.6186C9.79581 11.6186 9.62192 11.5467 9.47817 11.4031C9.33456 11.2594 9.26275 11.0855 9.26275 10.8815C9.26275 10.6774 9.33456 10.5036 9.47817 10.3598C9.62192 10.2161 9.79581 10.1442 9.99984 10.1442C10.2039 10.1442 10.3778 10.2161 10.5215 10.3598C10.6651 10.5036 10.7369 10.6774 10.7369 10.8815C10.7369 11.0855 10.6651 11.2594 10.5215 11.4031C10.3778 11.5467 10.2039 11.6186 9.99984 11.6186ZM13.3332 11.6186C13.1291 11.6186 12.9553 11.5467 12.8115 11.4031C12.6679 11.2594 12.5961 11.0855 12.5961 10.8815C12.5961 10.6774 12.6679 10.5036 12.8115 10.3598C12.9553 10.2161 13.1291 10.1442 13.3332 10.1442C13.5372 10.1442 13.7111 10.2161 13.8548 10.3598C13.9984 10.5036 14.0703 10.6774 14.0703 10.8815C14.0703 11.0855 13.9984 11.2594 13.8548 11.4031C13.7111 11.5467 13.5372 11.6186 13.3332 11.6186ZM4.42296 17.9167C4.00199 17.9167 3.64567 17.7708 3.354 17.4792C3.06234 17.1875 2.9165 16.8312 2.9165 16.4102V5.25647C2.9165 4.8355 3.06234 4.47918 3.354 4.18751C3.64567 3.89585 4.00199 3.75001 4.42296 3.75001H5.57671V2.62814C5.57671 2.4455 5.63789 2.293 5.76025 2.17064C5.88261 2.04842 6.03511 1.9873 6.21775 1.9873C6.40053 1.9873 6.55303 2.04842 6.67525 2.17064C6.79762 2.293 6.8588 2.4455 6.8588 2.62814V3.75001H13.173V2.6123C13.173 2.43494 13.2328 2.2864 13.3523 2.16668C13.4721 2.0471 13.6206 1.9873 13.798 1.9873C13.9753 1.9873 14.1238 2.0471 14.2434 2.16668C14.3631 2.2864 14.423 2.43494 14.423 2.6123V3.75001H15.5767C15.9977 3.75001 16.354 3.89585 16.6457 4.18751C16.9373 4.47918 17.0832 4.8355 17.0832 5.25647V16.4102C17.0832 16.8312 16.9373 17.1875 16.6457 17.4792C16.354 17.7708 15.9977 17.9167 15.5767 17.9167H4.42296ZM4.42296 16.6667H15.5767C15.6409 16.6667 15.6996 16.6399 15.753 16.5865C15.8064 16.5331 15.8332 16.4744 15.8332 16.4102V8.5898H4.1665V16.4102C4.1665 16.4744 4.19324 16.5331 4.24671 16.5865C4.30005 16.6399 4.3588 16.6667 4.42296 16.6667ZM4.1665 7.3398H15.8332V5.25647C15.8332 5.1923 15.8064 5.13355 15.753 5.08022C15.6996 5.02675 15.6409 5.00001 15.5767 5.00001H4.42296C4.3588 5.00001 4.30005 5.02675 4.24671 5.08022C4.19324 5.13355 4.1665 5.1923 4.1665 5.25647V7.3398Z" fill="#1C1C1C" fill-opacity="0.4" />
                                                </svg>
                                            }}
                                            format="DD-MMM-YY"
                                            slotProps={{
                                                textField: {
                                                    placeholder: "Choose date",
                                                    sx: {

                                                        width: "340px",
                                                        '& .MuiInputBase-root': {
                                                            height: "52px"
                                                        },
                                                        '& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
                                                            border: `1px solid ${BLACK.B_10}`,
                                                            borderRadius: '8px'
                                                        },

                                                        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                            border: `1px solid ${BLACK.B_10}`
                                                        },
                                                        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                                                            border: `1px solid ${BLACK.B_10}`
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                    </LocalizationProvider>
                                </div>
                            </div>
                            <div className="flex justify-between mt-6">
                                <div>
                                    <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_80 }}>Frequency</div>
                                    <Select
                                        onChange={onSelectFrequencyHandler}
                                        placeholder="Select Frequency"
                                        value={state?.time_slots?.type}
                                        indicator={
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path d="M9.99984 12.4791C9.88873 12.4791 9.78456 12.4617 9.68734 12.427C9.59012 12.3923 9.49984 12.3333 9.4165 12.2499L5.58317 8.41659C5.43039 8.26381 5.354 8.06936 5.354 7.83325C5.354 7.59714 5.43039 7.4027 5.58317 7.24992C5.73595 7.09714 5.93039 7.02075 6.1665 7.02075C6.40262 7.02075 6.59706 7.09714 6.74984 7.24992L9.99984 10.4999L13.2498 7.24992C13.4026 7.09714 13.5971 7.02075 13.8332 7.02075C14.0693 7.02075 14.2637 7.09714 14.4165 7.24992C14.5693 7.4027 14.6457 7.59714 14.6457 7.83325C14.6457 8.06936 14.5693 8.26381 14.4165 8.41659L10.5832 12.2499C10.4998 12.3333 10.4096 12.3923 10.3123 12.427C10.2151 12.4617 10.1109 12.4791 9.99984 12.4791Z" fill="#1C1C1C" fill-opacity="0.4" />
                                            </svg>

                                        }
                                        sx={{
                                            "--Input-focusedThickness": "0px",
                                            width: "340px",
                                            height: "52px",
                                            backgroundColor: WHITE.W_100,
                                            fontSize: 14,
                                            fontWeight: 400,
                                            lineHeight: "20px",
                                            borderColor: BLACK.B_10,
                                            [`& .${selectClasses.indicator}`]: {
                                                transition: '0.2s',
                                                [`&.${selectClasses.expanded}`]: {
                                                    transform: 'rotate(-180deg)',
                                                },
                                            },

                                        }}>
                                        <Option value={"daily"} >Daily</Option>
                                        <Option value={"weekly"} >Weekly</Option>
                                        {/* <Option value={"CLIENT"}>CLIENT</Option> */}
                                    </Select>
                                </div>
                                <div>
                                    <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_80 }}>Day</div>
                                    <div className="flex flex-row justify-between" style={{ pointerEvents: daysDisabled ? "none" : "auto", width: 340 }} >
                                        {
                                            weeks.map(week => {
                                                return <div key={week.name} onClick={() => onWeekDayClickHandler(week.name)} className="flex justify-center items-center cursor-pointer" style={{ fontSize: 14, fontWeight: 400, lineHeight: "20px", height: 52, width: 46, backgroundColor: selectedWeeks[week.name as keyof WeeksObject] ? PRIMARY.P_BLue : BLACK.B_10, borderRadius: 8, color: daysDisabled ? BLACK.B_20 : selectedWeeks[week.name as keyof WeeksObject] ? WHITE.W_100 : BLACK.B_100 }} >{week.label}</div>
                                            })
                                        }
                                    </div>
                                </div>

                            </div>
                            <div className="flex justify-between items-end mt-6">
                                <div>
                                    <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_80 }}>Time Slot</div>
                                    <TimeSlotInput setHourAndMinHandler={setHourAndMinHandler} oneTimeHourAndMin={oneTimeHourAndMin} />

                                </div>
                                {/* <div style={{ width: 340 }}  >
                        <Button
                            onClick={onAddTimeClick}
                            disabled={!toggleDisabled}
                            startDecorator={
                                toggleDisabled ? (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                        <path d="M5.1665 6.83341H0.999837C0.763726 6.83341 0.565809 6.75355 0.406087 6.59383C0.246365 6.43411 0.166504 6.23619 0.166504 6.00008C0.166504 5.76397 0.246365 5.56605 0.406087 5.40633C0.565809 5.24661 0.763726 5.16675 0.999837 5.16675H5.1665V1.00008C5.1665 0.76397 5.24636 0.566054 5.40609 0.406331C5.56581 0.246609 5.76373 0.166748 5.99984 0.166748C6.23595 0.166748 6.43386 0.246609 6.59359 0.406331C6.75331 0.566054 6.83317 0.76397 6.83317 1.00008V5.16675H10.9998C11.2359 5.16675 11.4339 5.24661 11.5936 5.40633C11.7533 5.56605 11.8332 5.76397 11.8332 6.00008C11.8332 6.23619 11.7533 6.43411 11.5936 6.59383C11.4339 6.75355 11.2359 6.83341 10.9998 6.83341H6.83317V11.0001C6.83317 11.2362 6.75331 11.4341 6.59359 11.5938C6.43386 11.7536 6.23595 11.8334 5.99984 11.8334C5.76373 11.8334 5.56581 11.7536 5.40609 11.5938C5.24636 11.4341 5.1665 11.2362 5.1665 11.0001V6.83341Z" fill="#1886FE" />
                                    </svg>
                                ) : (
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                        <path d="M9.1665 10.8334H4.99984C4.76373 10.8334 4.56581 10.7536 4.40609 10.5938C4.24637 10.4341 4.1665 10.2362 4.1665 10.0001C4.1665 9.76397 4.24637 9.56605 4.40609 9.40633C4.56581 9.24661 4.76373 9.16675 4.99984 9.16675H9.1665V5.00008C9.1665 4.76397 9.24636 4.56605 9.40609 4.40633C9.56581 4.24661 9.76373 4.16675 9.99984 4.16675C10.2359 4.16675 10.4339 4.24661 10.5936 4.40633C10.7533 4.56605 10.8332 4.76397 10.8332 5.00008V9.16675H14.9998C15.2359 9.16675 15.4339 9.24661 15.5936 9.40633C15.7533 9.56605 15.8332 9.76397 15.8332 10.0001C15.8332 10.2362 15.7533 10.4341 15.5936 10.5938C15.4339 10.7536 15.2359 10.8334 14.9998 10.8334H10.8332V15.0001C10.8332 15.2362 10.7533 15.4341 10.5936 15.5938C10.4339 15.7536 10.2359 15.8334 9.99984 15.8334C9.76373 15.8334 9.56581 15.7536 9.40609 15.5938C9.24636 15.4341 9.1665 15.2362 9.1665 15.0001V10.8334Z" fill="#1C1C1C" fill-opacity="0.1" />
                                    </svg>
                                )
                            }
                            sx={{
                                height: "52px",
                                width: "128px",
                                paddingX: "16px",
                                backgroundColor: WHITE.W_100,



                                color: PRIMARY.P_BLue,
                                border: `1px solid ${PRIMARY.P_BLue}`,


                                ":hover": {
                                    backgroundColor: WHITE.W_100,
                                },
                                ":disabled": {
                                    color: BLACK.B_10,
                                    border: `1px solid ${BLACK.B_10}`,
                                    backgroundColor: WHITE.W_100,

                                }
                            }}
                        // onClick={() => setOpen(false)}
                        >Add Time</Button>
                    </div> */}
                            </div>
                            {
                                // timeSlotArray.length > 0 && (
                                //     <div className="flex flex-wrap mt-2" >
                                //         {
                                //             timeSlotArray.map((timeSlot, index) => {
                                //                 let marginLeft = index % 7 === 0 ? 0 : 8;
                                //                 let marginTop = index > 6 ? 8 : 0;
                                //                 return (
                                //                     <div className="flex flex-row justify-between px-2 items-center" style={{ marginTop: marginTop, marginLeft: marginLeft, height: 28, width: 94, borderRadius: 4, backgroundColor: BLACK.B_5 }} >
                                //                         <div style={{ fontSize: 12, fontWeight: 500, lineHeight: "18px" }} >{timeSlot}</div>
                                //                         <svg onClick={() => onDeleteTimeSlot(timeSlot)} className="cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                //                             <path d="M13.5137 7.94219L11.4551 10L13.5137 12.0578C13.5718 12.1159 13.6179 12.1848 13.6493 12.2607C13.6807 12.3366 13.6969 12.4179 13.6969 12.5C13.6969 12.5821 13.6807 12.6634 13.6493 12.7393C13.6179 12.8152 13.5718 12.8841 13.5137 12.9422C13.4557 13.0003 13.3867 13.0463 13.3108 13.0777C13.235 13.1092 13.1537 13.1253 13.0715 13.1253C12.9894 13.1253 12.9081 13.1092 12.8322 13.0777C12.7564 13.0463 12.6874 13.0003 12.6293 12.9422L10.5715 10.8836L8.51372 12.9422C8.45566 13.0003 8.38672 13.0463 8.31085 13.0777C8.23498 13.1092 8.15366 13.1253 8.07154 13.1253C7.98942 13.1253 7.9081 13.1092 7.83223 13.0777C7.75636 13.0463 7.68742 13.0003 7.62935 12.9422C7.57128 12.8841 7.52522 12.8152 7.49379 12.7393C7.46236 12.6634 7.44619 12.5821 7.44619 12.5C7.44619 12.4179 7.46236 12.3366 7.49379 12.2607C7.52522 12.1848 7.57128 12.1159 7.62935 12.0578L9.68794 10L7.62935 7.94219C7.51207 7.82491 7.44619 7.66585 7.44619 7.5C7.44619 7.33415 7.51207 7.17509 7.62935 7.05781C7.74662 6.94054 7.90568 6.87465 8.07154 6.87465C8.23739 6.87465 8.39645 6.94054 8.51372 7.05781L10.5715 9.11641L12.6293 7.05781C12.6874 6.99974 12.7564 6.95368 12.8322 6.92225C12.9081 6.89083 12.9894 6.87465 13.0715 6.87465C13.1537 6.87465 13.235 6.89083 13.3108 6.92225C13.3867 6.95368 13.4557 6.99974 13.5137 7.05781C13.5718 7.11588 13.6179 7.18482 13.6493 7.26069C13.6807 7.33656 13.6969 7.41788 13.6969 7.5C13.6969 7.58212 13.6807 7.66344 13.6493 7.73931C13.6179 7.81518 13.5718 7.88412 13.5137 7.94219ZM18.6965 10C18.6965 11.607 18.22 13.1779 17.3272 14.514C16.4344 15.8502 15.1655 16.8916 13.6808 17.5065C12.1962 18.1215 10.5625 18.2824 8.98643 17.9689C7.41033 17.6554 5.9626 16.8815 4.82629 15.7452C3.68999 14.6089 2.91616 13.1612 2.60266 11.5851C2.28915 10.009 2.45005 8.37535 3.06502 6.8907C3.67998 5.40605 4.72138 4.1371 6.05753 3.24431C7.39368 2.35152 8.96456 1.875 10.5715 1.875C12.7257 1.87727 14.791 2.73403 16.3143 4.25727C17.8375 5.78051 18.6943 7.84581 18.6965 10ZM17.4465 10C17.4465 8.64025 17.0433 7.31104 16.2879 6.18045C15.5325 5.04987 14.4587 4.16868 13.2025 3.64833C11.9462 3.12798 10.5639 2.99183 9.23029 3.2571C7.89667 3.52237 6.67166 4.17716 5.71018 5.13864C4.74869 6.10013 4.09391 7.32513 3.82864 8.65875C3.56336 9.99237 3.69951 11.3747 4.21986 12.6309C4.74022 13.8872 5.6214 14.9609 6.75199 15.7164C7.88258 16.4718 9.21179 16.875 10.5715 16.875C12.3943 16.8729 14.1417 16.1479 15.4306 14.8591C16.7195 13.5702 17.4445 11.8227 17.4465 10Z" fill="#1C1C1C" fill-opacity="0.4" />
                                //                         </svg>
                                //                     </div>
                                //                 )
                                //             })
                                //         }

                                //     </div>
                                // )
                            }
                            <div className="mt-6" >
                                <div className="mb-1" style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: BLACK.B_80 }}>Email ID</div>
                                <Input
                                    autoComplete="off"
                                    onChange={onInputChangeHandler}
                                    value={emails}
                                    placeholder="Enter email IDs for notification, separated by ‘ , ‘"
                                    sx={{
                                        "--Input-focusedThickness": "0px",
                                        width: "708px",
                                        height: "52px",
                                        backgroundColor: WHITE.W_100,
                                        fontSize: 14,
                                        fontWeight: 400,
                                        lineHeight: "20px",
                                        borderRadius: 8,
                                        borderColor: BLACK.B_10,
                                    }}
                                    name="company_name"
                                // onChange={onChangeHandler}
                                />
                            </div>
                            <div className="flex flex-row justify-between mt-10">
                                <Button color="neutral"
                                    sx={{
                                        height: "48px",
                                        width: "340px",
                                        backgroundColor: BLACK.B_5,
                                        color: BLACK.B_100,
                                        ":hover": {
                                            backgroundColor: BLACK.B_20,
                                        }
                                    }}
                                    onClick={() => setOpenModal(false)}
                                >Cancel</Button>
                                <Button
                                    loading={loading}
                                    // onClick={onSaveClickHandler}
                                    // endDecorator={
                                    //     <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                                    //         <path d="M17.8172 10.4425L12.1922 16.0675C12.0749 16.1848 11.9159 16.2507 11.75 16.2507C11.5841 16.2507 11.4251 16.1848 11.3078 16.0675C11.1905 15.9503 11.1247 15.7912 11.1247 15.6253C11.1247 15.4595 11.1905 15.3004 11.3078 15.1832L15.8664 10.6253H3.625C3.45924 10.6253 3.30027 10.5595 3.18306 10.4423C3.06585 10.3251 3 10.1661 3 10.0003C3 9.83459 3.06585 9.67562 3.18306 9.55841C3.30027 9.4412 3.45924 9.37535 3.625 9.37535H15.8664L11.3078 4.81753C11.1905 4.70026 11.1247 4.5412 11.1247 4.37535C11.1247 4.2095 11.1905 4.05044 11.3078 3.93316C11.4251 3.81588 11.5841 3.75 11.75 3.75C11.9159 3.75 12.0749 3.81588 12.1922 3.93316L17.8172 9.55816C17.8753 9.61621 17.9214 9.68514 17.9529 9.76101C17.9843 9.83688 18.0005 9.91821 18.0005 10.0003C18.0005 10.0825 17.9843 10.1638 17.9529 10.2397C17.9214 10.3156 17.8753 10.3845 17.8172 10.4425Z" fill="white" />
                                    //     </svg>
                                    // }
                                    sx={{
                                        height: "48px",
                                        width: "340px",
                                        backgroundColor: PRIMARY.P_BLue,
                                    }}
                                    onClick={() => onSaveClickHandler(true)}
                                >Save</Button>
                            </div>
                        </>
                    )
                }

            </>
        )
    }


    const onNextClickHandler = (state: UploadStateObject) => {


        setFileDetail(state);
        setView(state.schedule_type);
    }



    return (
        <Modal
            open={true}
            sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            className="h-full"
        >
            <div
                style={{ width: 790 }}
                className="flex flex-col border rounded-lg px-10 py-10 bg-white"
            >


                {
                    view === "upload_file" && <UploadFileComponent onNextClickHandler={onNextClickHandler} fileDetail={fileDetail} setFileDetail={setFileDetail} />
                }

                {
                    view === "one_time" && <OneTimeSchedulingDetailComponent setRefresh={setRefresh} />
                }

                {
                    view === "recurring" && <RecurringSchedulingDetailComponent setRefresh={setRefresh} />
                }

            </div>
        </Modal>
    )
}

export default AddBulkScheduleModal;